// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T18:40:04.571Z
// Property: FUZE Lucan (ID: 6767906449167810)
// Collections: 29 amenities, 5 floorplans (live), 46 photos, 65 POIs, 5 reviews, 2 virtual tours, 5 office hours, 9 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162477",
  "multihub_property_id": "6767906449167810",
  "property_external_id": "9kx8kq4",
  "property_zillow_url": "https://www.zillow.com/apartments/south-huron-on/fuze-lucan/CjFTLy/",
  "property_apartments_url": "https://www.apartments.com/fuze-lucan-lucan-on/9kx8kq4/",
  "property_google_business_url": "https://www.google.com/maps/place/FUZE+Lucan/@43.1928217,-81.4131987,834m/data=!3m2!1e3!4b1!4m6!3m5!1s0x882edd72697c85b7:0xcc32115616fc0801!8m2!3d43.1928217!4d-81.4131987!16s%2Fg%2F11wc9tdz59!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MTAxMS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58860784795",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fuze-lucan",
  "property_name": "FUZE Lucan",
  "property_website_url": "https://www.fuzelucan.com/",
  "property_domain": "https://www.fuzelucan.com/",
  "property_address": "280 Main St",
  "property_full_address": "280 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
  "property_address_1": "280 Main St",
  "property_address_2": null,
  "property_address_city": "Lucan Biddulph",
  "property_address_state": "ON",
  "property_address_zip_full": null,
  "property_address_zip": "N0M 2J0",
  "property_address_country": "CA",
  "property_address_county": "Middlesex County",
  "property_neighborhood_address": "Southwest Ontario Area",
  "property_address_latitude": "43.1931552",
  "property_address_longitude": "-81.4130784",
  "property_email": null,
  "property_phone": "(866) 721-3102",
  "property_call_tracking_phone": null,
  "property_company_name": "Z Modular",
  "property_company_url": "https://www.z-modular.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern Main Street living, built smarter.</strong> Explore Canadian-built studio, one-, and two-bedroom <a href=\"/floor-plans\">floor plans</a> with 9' ceilings, extra sound-proofing, stainless steel appliances, in-suite laundry, and glass-railing balconies—then <a href=\"/schedule-a-tour\">schedule a tour</a> of FUZE Lucan.</p>",
  "property_long_description": "<p><strong>Modern Main Street living, built smarter.</strong> At FUZE Lucan, you get a fresh take on apartment living in Lucan Biddulph: Canadian-built, Canadian-owned suites crafted with innovative off-site steel construction, extra sound-proofing, 9' ceilings, key-fob entry, premium wood-style flooring, stainless steel appliances, in-suite laundry, and glass-railing balconies. Choose from smart studio, one-bedroom, and two-bedroom <a href=\"/floor-plans\">floor plans</a> designed for everyday ease.</p><p><strong>Connected to the best of Lucan.</strong> Step outside to the Community Memorial Centre, local parks, the dog park, outdoor pool, and sports fields, with Main Street favourites like The Hub Roadhouse, Dessert First Bakery Cafe, Thai Pad, Donnelly’s Cafe, Lucan Foodland, and other everyday stops nearby. Back home, a <a href=\"/amenities\">fitness centre, lounge and games room</a>, community kitchen, indoor bike storage, pet wash station, elevator, parking, storage, and on-site management keep life streamlined—while Highway 4 puts London, Grand Bend, and Stratford within an easy regional drive.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a14132-19ef-7205-8478-0be7435ce7a3.webp",
  "property_featured_image_media": {
    "alt_text": "Community lounge with a fireplace and a large dining table.",
    "public_id": "01a14132-19ef-7205-8478-0be7435ce7a3",
    "storage_key": "property/6767906449167810/01a14132-19ef-7205-8478-0be7435ce7a3.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167810/01a117e8-a104-71bb-9afc-eff07c14ef74.mp4",
  "property_featured_video_media": {
    "public_id": "01a117e8-a104-71bb-9afc-eff07c14ef74",
    "storage_key": "property/6767906449167810/01a117e8-a104-71bb-9afc-eff07c14ef74.mp4",
    "thumbnail_key": "property/6767906449167810/01a117e8-a104-71bb-9afc-eff07c14ef74_thumb.webp",
    "size_bytes": 7885729,
    "classification": "Community",
    "title": "Explore Our Modern Apartments and Amenities",
    "description": "Discover the perfect blend of comfort and convenience in our vibrant apartment community. Featuring spacious units, a state-of-the-art gym, and inviting common areas."
  },
  "property_total_units": "90",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": "50",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "67.77777777777779",
  "property_admin_fee": "200",
  "property_application_fee": null,
  "property_fees_deposit_info": "Security deposit: $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs are welcome; breed restrictions may apply; a maximum of two pets per apartment home is allowed.",
  "property_pet_policy_description": "Cats and dogs are welcome at FUZE Lucan, as permitted by Ontario law. Breed restrictions may apply. A maximum of two pets per apartment home is allowed. No specific weight limits or pet rent/fees are listed.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cb-a048-7745-9c4a-acb6e563e8d0.webp",
  "property_primary_logo_media": {
    "alt_text": "FUZE LUCAN property logo",
    "public_id": "01a117cb-a048-7745-9c4a-acb6e563e8d0",
    "storage_key": "property/6767906449167810/01a117cb-a048-7745-9c4a-acb6e563e8d0.webp",
    "width": 794,
    "height": 122
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a13b3f-c80a-72f5-9b58-bfa8eea76c0c.webp",
  "property_secondary_logo_media": {
    "alt_text": "Fuze Lucan logo",
    "public_id": "01a13b3f-c80a-72f5-9b58-bfa8eea76c0c",
    "storage_key": "property/6767906449167810/01a13b3f-c80a-72f5-9b58-bfa8eea76c0c.webp",
    "width": 454,
    "height": 292
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
  "property_fav_icon_media": {
    "alt_text": "Red and brown Z logo",
    "public_id": "01a13b82-360e-700b-a136-440b6b7cfdcf",
    "storage_key": "company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
    "width": 1080,
    "height": 1080
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a16033-0254-7703-9e5a-842ae52038dc.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Fuze Lucan logo",
    "public_id": "01a16033-0254-7703-9e5a-842ae52038dc",
    "storage_key": "property/6767906449167810/01a16033-0254-7703-9e5a-842ae52038dc.webp",
    "width": 794,
    "height": 122
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cb-bc3f-7229-9abd-46f7c9e3ba8d.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a117cb-bc3f-7229-9abd-46f7c9e3ba8d",
    "storage_key": "property/6767906449167810/01a117cb-bc3f-7229-9abd-46f7c9e3ba8d.webp",
    "width": 794,
    "height": 122
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-a1b4-75fa-8eea-2a352ae0cd0e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-9f9c-7250-a571-60b30bf57b15.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-a0ab-7569-bf2b-4298ffba6543.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#2a535e",
  "property_secondary_color": "#0f2c33",
  "property_font_color": null,
  "property_color_4": "#e51837",
  "property_color_3": "#ffffff",
  "property_color_5": "#231f20",
  "property_color_6": "#931903",
  "property_color_7": "#e51837",
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "351 - 876 sq ft",
  "property_sqft_min": "351",
  "property_sqft_max": "876",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 29,
  "property_facebook_url": "https://www.facebook.com/fuzelucan",
  "property_instagram_url": "https://www.instagram.com/fuze_lucan/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJt4V8aXLdLogRAQj8FlYRMsw",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to FUZE Lucan",
  "property_home_romance_title": "Embrace a Life You Love in Your New Home",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built in.</strong> FUZE Lucan brings practical perks and polished spaces together, from a fitness centre, indoor bike storage, and pet wash station to on-site management and maintenance. Stretch out beyond your suite in the lounge and games room, community kitchen, and dining room—then come home to keyless entry, full-size laundry, stainless steel appliances, 9' ceilings, spacious closets, glass-railing balconies, and extra sound-proofing.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore studio, one-bedroom, and two-bedroom apartments at FUZE Lucan, including select two-bath layouts and glass-railing balconies.</p><p>Each home brings practical polish with full-size in-suite laundry, stainless steel appliances, dishwasher, microwave, air conditioning, roller blinds, wood-style flooring, LED lighting, spacious closets, 9' ceilings, and added sound-proofing for a quieter feel.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at FUZE Lucan.</strong> Preview bright modern suites with stainless steel appliances, clean cabinetry, premium wood-style flooring, and glass-railing balconies. Then browse amenity spaces built into everyday living, from the fitness centre to the lounge, games room, community kitchen, and dining room.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Main Street ease, Lucan colour.</strong> FUZE Lucan puts daily stops close at hand—from coffee at On Table Café and takeout at Sunshine Restaurant to errands at Glenns Shopping Centre. Recreation is just down the street at the Lucan Biddulph Community Memorial Centre, with Optimist Elm Street Park nearby for green space, a splash pad, and an all-wheels park. Explore the map to see how local dining, parks, and weekday transit connections come together around 280 Main St.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews point to the details that matter:</strong> responsive on-site care, spotless shared spaces, and a building that feels well looked after every day. Residents call out Morgan and Tim for friendly, quick support, along with modern apartments, a well-equipped gym, cozy gathering areas, balcony views, beautiful sunsets, and the small everyday moments that make FUZE Lucan memorable.</p>",
  "property_neighborhood_blurb": "<p><strong>Small-town convenience, mapped around you.</strong> From FUZE Lucan, everyday stops and local colour are easy to explore—coffee and comfort fare at On Table Café, takeout from Sunshine Restaurant, errands at Glenns Shopping Centre, and recreation just down the street at the Lucan Biddulph Community Memorial Centre.</p><p>Use the interactive map to get a feel for a neighborhood where Main Street connects dining, green space, and regional access in one simple rhythm. Optimist Elm Street Park adds a splash pad and all-wheels park nearby, while Middlesex County Connect Route 1 links Lucan with Ilderton, Arva, Fanshawe College, Masonville, and London on weekdays. Then come home to modern comfort, smart finishes, and shared spaces designed for easier downtime—see more on the <a href=\"/amenities\">amenities</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the location in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>More ease in every part of the building.</strong> At FUZE Lucan, amenities are designed to make daily routines feel smoother—work out in the fitness centre, tuck your bike into indoor storage, rinse off paws at the pet wash station, and rely on on-site management and maintenance for added peace of mind.</p><p>When you want room beyond your suite, the lounge and games room, community kitchen, and dining room create comfortable spaces to relax, connect, or host. Back at home, keyless entry, full-size laundry, stainless steel appliances, air conditioning, premium wood-style flooring, 9' ceilings, spacious closets, LED lighting, roller blinds, glass-railing balconies, and extra sound-proofing bring a polished, quieter feel to everyday living. Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities up close.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for FUZE Lucan.</strong> Choose modern Main Street living with Canadian-built suites, 9' ceilings, extra sound-proofing, key-fob entry, stainless steel appliances, in-suite laundry, and smart studio, one-bedroom, and two-bedroom layouts. Apply online today and take the next step toward calling FUZE Lucan home.</p>",
  "property_contactus_blurb": "<p><strong>Questions about FUZE Lucan?</strong> Contact our leasing team for details on modern Main Street suites, available studio, one-bedroom, and two-bedroom layouts, or directions to 280 Main St. We’re here to help you take the next step toward smarter apartment living in Lucan Biddulph.</p>",
  "property_faqs_blurb": "<p><strong>Questions about FUZE Lucan?</strong> Start here for quick answers about the community, leasing, suite features, and everyday living at 280 Main St. From smart floor plans to on-site conveniences, this FAQ covers the basics—and the leasing team is happy to help with anything else.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your rhythm.</strong> FUZE Lucan’s floor plans range from a streamlined studio to one-bedroom designs with more room to spread out and two-bedroom layouts, including an option with two baths for added flexibility.</p><p>Inside, each plan is built around everyday function: full-size in-suite laundry, stainless steel appliances, a dishwasher and microwave, air conditioning, roller blinds, premium wood-style flooring, LED lighting, spacious closets, and 9' ceilings that help each home feel open and polished. Select layouts add glass-railing balconies, while extra sound-proofing supports a quieter living experience.</p><p>Browse current availability, compare pricing, and see which studio, one-bedroom, or two-bedroom apartment in Lucan feels like the right fit—then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the layouts in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you tour.</strong> Browse FUZE Lucan’s photo gallery for a closer look at bright, modern apartments and the shared spaces that shape your day. Picture stainless steel appliances against clean cabinetry, premium wood-style flooring carrying through open living areas, and glass-railing balconies that add light and a polished finish.</p><p>Move from suite views to amenity scenes: a fitness centre ready for quick workouts, a lounge and games room made for downtime, and a community kitchen and dining room with space to gather. Like what you see? Explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the finishes, layouts, and building atmosphere in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore FUZE Lucan on the map.</strong> See available studio, one-bedroom, and two-bedroom apartments on Main Street, then get a feel for nearby parks, local dining, everyday stops, and Highway 4 connections to London, Grand Bend, and Stratford.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with the messy parts made easier.</strong> At FUZE Lucan, your cat or dog can settle into a modern apartment that keeps daily routines simple—from spacious closets for leashes and supplies to in-suite laundry for blankets, towels, and rainy-day cleanups. After muddy walks, the on-site pet wash station helps you skip the bathtub wrestle and keep your home feeling fresh.</p><p>Step out for a quick stroll along Main Street, pick up essentials from a local pet shop nearby, or head to the township dog park for off-leash time during posted hours. Ready to see how the building supports life with pets? Explore the <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share Main Street living, built smarter.</strong> Love the 9' ceilings, in-suite laundry, stainless steel appliances, extra sound-proofing, and easy everyday comforts at FUZE Lucan? Invite a friend to experience the same fresh take on apartment living—send your referral today.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at FUZE Lucan.</strong> Keep Main Street living streamlined—pay rent, submit maintenance requests, and manage your account online. From smart, modern suites to on-site management, this is your quick connection to everyday ease at FUZE Lucan.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the people who’ve lived it.</strong> As you read FUZE Lucan reviews, a clear theme comes through: attentive on-site care, spotless common areas, and a building that feels thoughtfully managed day to day.</p><p>Residents often mention Morgan and Tim by name for being friendly, responsive, and easy to talk to, with maintenance concerns handled quickly. You’ll also see praise for modern, cozy apartments, an “immaculately clean” building, a well-equipped gym, and inviting spaces for relaxing or gathering. From balcony views and beautiful sunsets to small wildlife sightings, reviews reflect the everyday details that make life here memorable.</p>",
  "property_created_at": "1791400486278",
  "property_scheduletour_blurb": "<p><strong>See smarter Main Street living up close.</strong> Tour FUZE Lucan and experience the 9' ceilings, extra sound-proofing, stainless steel appliances, in-suite laundry, glass-railing balconies, and fresh studio to two-bedroom layouts in person. Book your visit today and picture everyday ease at 280 Main St.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks for reaching out to FUZE Lucan.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture modern Main Street living with Canadian-built suites, 9' ceilings, extra sound-proofing, in-suite laundry, stainless steel appliances, and thoughtful spaces designed for everyday ease.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the community before you arrive.</strong> FUZE Lucan’s virtual tours let you move through the building’s shared spaces at your own pace, from the fitness centre to the lounge and games room, plus the community kitchen and dining room designed for easy gathering.</p><p>Use Virtual Tour 1 and Virtual Tour 2 to get a clearer feel for finishes, flow, lighting, and the modern atmosphere that photos can only partly capture. When you’re ready to look closer, browse the <a href=\"/gallery\">photo gallery</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience FUZE Lucan in person.</p>",
  "property_copyright": "2026 All Rights Reserved. FUZE Lucan",
  "property_seo_title_home": "Apartments for Rent in Lucan, ON | FUZE Lucan",
  "property_seo_description_home": "New studio, 1 & 2 bedroom apartments for rent in Lucan, Ontario, a short drive from London. In-suite laundry, fitness centre & pet wash. Book a tour!",
  "property_seo_title_floorplans": "Studio, 1 & 2 Bedroom Apartments in Lucan, ON | FUZE",
  "property_seo_description_floorplans": "Compare studio, 1 & 2 bedroom floor plans at FUZE Lucan. Every suite has 9' ceilings, a full-size washer & dryer and extra sound-proofing. View pricing.",
  "property_seo_title_amenities": "Amenities | New Apartments in Lucan, ON | FUZE Lucan",
  "property_seo_description_amenities": "Fitness centre, lounge + games room, community kitchen, pet wash station & indoor bike storage. Modern apartment living at FUZE Lucan in Lucan, Ontario.",
  "property_seo_title_gallery": "Photos | Lucan, ON Apartments for Rent | FUZE Lucan",
  "property_seo_description_gallery": "See FUZE Lucan in photos: studio, 1 & 2 bedroom suites with stainless appliances, glass-railing balconies and wood-style floors in Lucan, ON.",
  "property_seo_title_virtualtours": "Virtual Tours | Lucan, ON Apartments | FUZE Lucan",
  "property_seo_description_virtualtours": "Take a virtual tour of FUZE Lucan's studio, 1 & 2 bedroom apartments in Lucan, Ontario, from 9' ceilings to glass-railing balconies. Explore now.",
  "property_seo_title_interactivemap": "Interactive Map | FUZE Lucan Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at FUZE Lucan! Explore studio to two-bedroom apartments with luxury amenities. Check our map for prices!",
  "property_seo_title_neighborhood": "Living in Lucan Biddulph, ON, Near London | FUZE Lucan",
  "property_seo_description_neighborhood": "Small-town Lucan Biddulph living with an easy drive to London, Ontario. Explore local parks, shops and dining near FUZE Lucan at 280 Main St.",
  "property_seo_title_contact": "Contact FUZE Lucan | 280 Main St, Lucan, ON N0M 2J0",
  "property_seo_description_contact": "Visit FUZE Lucan at 280 Main St., Lucan, ON N0M 2J0, or contact our leasing team about studio, 1 & 2 bedroom availability. We'd love to hear from you.",
  "property_seo_title_faqs": "FAQs | Renting at FUZE Lucan Apartments in Lucan, ON",
  "property_seo_description_faqs": "How to apply, income requirements, pet policy and office hours at FUZE Lucan. Get answers before you rent your new apartment in Lucan, Ontario.",
  "property_seo_title_reviews": "Resident Reviews | FUZE Lucan Apartments, Lucan, ON",
  "property_seo_description_reviews": "Read what residents say about living at FUZE Lucan, with new studio, 1 & 2 bedroom apartments in Lucan, Ontario.",
  "property_seo_title_applynow": "Apply Now | FUZE Lucan Apartments in Lucan, ON",
  "property_seo_description_applynow": "Apply online for a studio, 1 or 2 bedroom apartment at FUZE Lucan in Lucan, Ontario. Choose your floor plan and click Lease Now to get started.",
  "property_seo_title_residentaccess": "Resident Access | FUZE Lucan",
  "property_seo_description_residentaccess": "Login to FUZE Lucan's resident portal for seamless rent payments, maintenance requests, and community updates. Your comfort and convenience await!",
  "property_seo_title_referafriend": "Refer A Friend | FUZE Lucan",
  "property_seo_description_referafriend": "Great friends make great neighbors at FUZE Lucan! Refer a friend today and enjoy the vibrant lifestyle and community you both deserve in Lucan Biddulph, ON!",
  "property_seo_title_scheduletour": "Tour Apartments in Lucan, ON | FUZE Lucan",
  "property_seo_description_scheduletour": "Book a tour of FUZE Lucan's new studio, 1 & 2 bedroom apartments at 280 Main St. in Lucan, Ontario. Pick a time that works for you.",
  "property_seo_title_privacy": "Privacy Policy | FUZE Lucan",
  "property_seo_description_privacy": "Protecting your privacy is our priority at FUZE Lucan. Read our privacy policy to learn how we safeguard your information in Lucan Biddulph, ON.",
  "property_seo_title_accessibility": "Website Accessibility | FUZE Lucan",
  "property_seo_description_accessibility": "Experience inclusive living at FUZE Lucan in Lucan Biddulph, ON. Our commitment to accessibility ensures everyone feels at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | FUZE Lucan",
  "property_seo_description_sitemap": "Uncover the layout of FUZE Lucan in Biddulph, ON—your future home awaits! Navigate our sitemap for a seamless journey through our vibrant community.",
  "property_seo_title_thankyou": "Thank You | FUZE Lucan",
  "property_seo_description_thankyou": "Thank you for reaching out to FUZE Lucan! Our team will connect soon to help you discover your perfect home in Lucan Biddulph. Stay tuned!",
  "property_seo_title_pets": "Pet-Friendly Apartments in Lucan, ON | FUZE Lucan",
  "property_seo_description_pets": "FUZE Lucan is pet friendly, with an on-site pet wash station. Review our pet policy for studio, 1 & 2 bedroom apartments in Lucan, Ontario.",
  "property_updated_at": "1793725269463",
  "amenities": [
    {
      "id": "custom_5fa3141f-99ff-4529-9f0a-1a8a36ad0863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd2f672b-6f5d-4171-a522-65dd7ef3dc25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d025706-943e-4b5e-a4af-96f9369e6a78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b0daf5a-0b03-4eb6-941d-7c3e1b1ce27d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f1e30460-0bfc-44f3-bbe3-0d9e78974476",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size Washer + Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9b3f13d-b4bb-4a98-b733-a545cf5c4929",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Glass Railing Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5fc7364-4d35-4302-a0d5-414b2e0ba06d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Key-Fob Lock Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9bfc904-3626-4f63-b7f3-b2606f9bdfda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Roller Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9669a819-82c2-4a7a-bb22-b5baea902a82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Premium Wood-Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb12b454-97a6-403e-8523-4c17f774700b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53afd435-7d1a-415a-b7f7-422a5f99bffe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Extra Sound-Proofing for a Peaceful Living Experience",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9efbece-7cf9-4a6e-bc63-9b027bc3409b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "LED Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8dfb4603-cf67-434c-95f9-7ac9357d71b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28451801-93a5-4b22-b0d6-10bcf3a17a3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Centre",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b43d656b-41ec-4a08-9f4e-1f6e527bc20a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_299d196f-22bd-4531-8fd4-bc267cd76891",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5de0ac07-903c-446a-a94e-9e23be449d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c162a60-74b1-4641-9c3c-68856a2ad235",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dee900cf-216b-42fb-bf0d-b9d422f74021",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Indoor Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e5f00db2-019e-4cb0-9a71-62ebfb0e0a42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9aa0797-9f9d-4034-8fa7-690f7b04b8b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Keyless Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ca6f9fe-ef99-46f4-a961-51e4906e56b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3505b875-50ca-4a70-b2e2-1f99d7332b36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2010248-384c-46f7-b77b-02b4f208be78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Lounge + Games Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3615e5f5-0f0d-481d-9f99-3c0bd359746a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Community Kitchen & Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c40deae-b60d-46a9-8c48-e095ea786cfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Visitor Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a40e0154-2729-453a-b69e-ecb756c282b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba18cff8-b726-4127-b5df-ec88da80e009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fae107ad-d766-48f3-adc0-b8153f081729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "external_id": "false",
      "title": "Canadian Built and owned",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_558abf4d-e91d-4c80-8d00-1e6c280ac646",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ce-0028-72b6-bba6-42e13017f6ee.webp",
      "image_media": {
        "alt_text": "Modern community room with a fireplace, TV, and dining tables.",
        "public_id": "01a117ce-0028-72b6-bba6-42e13017f6ee",
        "storage_key": "property/6767906449167810/01a117ce-0028-72b6-bba6-42e13017f6ee.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather and socialize in our stylish community room, featuring a cozy fireplace, entertainment options, and comfortable seating for all residents.",
      "link": "",
      "alt_text": "Modern community room with a fireplace, TV, and dining tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b41da4f0-4ace-4bda-9bd7-33a96dbc5ab7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-f76f-7438-ba33-11424c7576d2.webp",
      "image_media": {
        "alt_text": "Community lounge area with a fireplace and large tables.",
        "public_id": "01a117cd-f76f-7438-ba33-11424c7576d2",
        "storage_key": "property/6767906449167810/01a117cd-f76f-7438-ba33-11424c7576d2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish community lounge, complete with a cozy fireplace and ample seating for socializing.",
      "link": "",
      "alt_text": "Community lounge area with a fireplace and large tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b515451c-f13c-4a26-9521-1d1cef025a02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-f3a4-703a-8902-625edccf09ac.webp",
      "image_media": {
        "alt_text": "Modern co-working space with communal tables, bar seating, and a full kitchen.",
        "public_id": "01a117cd-f3a4-703a-8902-625edccf09ac",
        "storage_key": "property/6767906449167810/01a117cd-f3a4-703a-8902-625edccf09ac.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a modern co-working space with plenty of room to work and socialize. Featuring communal tables, bar seating, and a full kitchen, this space is perfect for residents looking for a productive and connected environment.",
      "link": "",
      "alt_text": "Modern co-working space with communal tables, bar seating, and a full kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_096275cb-85d9-4a62-aa69-c2d5a5fe309c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-ecd8-7647-93c5-db5ea646d531.webp",
      "image_media": {
        "alt_text": "Modern lounge area with long communal tables, bar seating, and a fireplace with a TV above it.",
        "public_id": "01a117cd-ecd8-7647-93c5-db5ea646d531",
        "storage_key": "property/6767906449167810/01a117cd-ecd8-7647-93c5-db5ea646d531.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather and socialize in our stylish communal lounge, featuring comfortable seating, a modern fireplace, and a large television for entertainment.",
      "link": "",
      "alt_text": "Modern lounge area with long communal tables, bar seating, and a fireplace with a TV above it.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93c2d727-0780-4a7c-802e-e335df7d6fcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-ec22-700e-ade8-45f477182905.webp",
      "image_media": {
        "alt_text": "Modern community lounge with kitchen, dining tables, and bar seating.",
        "public_id": "01a117cd-ec22-700e-ade8-45f477182905",
        "storage_key": "property/6767906449167810/01a117cd-ec22-700e-ade8-45f477182905.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish community lounge, featuring a full kitchen and ample seating for dining or working.",
      "link": "",
      "alt_text": "Modern community lounge with kitchen, dining tables, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_03125eef-f2c1-4289-959b-ad3dc8062b15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-e772-7257-83be-0fcccf933466.webp",
      "image_media": {
        "alt_text": "Community lounge area with a modern kitchen island, dining table, fireplace, and TV.",
        "public_id": "01a117cd-e772-7257-83be-0fcccf933466",
        "storage_key": "property/6767906449167810/01a117cd-e772-7257-83be-0fcccf933466.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather with friends and family in the stylish community lounge, featuring a fully equipped kitchen, a large dining table, a cozy fireplace, and entertainment options.",
      "link": "",
      "alt_text": "Community lounge area with a modern kitchen island, dining table, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d68fdd8a-ffd0-4512-9a8b-2cdc47ad010d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-e613-77ad-813b-69bed0d9cab9.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a full kitchen, fireplace, and gathering tables.",
        "public_id": "01a117cd-e613-77ad-813b-69bed0d9cab9",
        "storage_key": "property/6767906449167810/01a117cd-e613-77ad-813b-69bed0d9cab9.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Gather in style in our modern community lounge, featuring a fully equipped kitchen, cozy fireplace, and ample seating for socializing and events.",
      "link": "",
      "alt_text": "Modern community lounge with a full kitchen, fireplace, and gathering tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c81f262-19dd-4949-bffe-5ec858954230",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-df39-7770-8f67-c3c9c8a22e77.webp",
      "image_media": {
        "alt_text": "Modern community lounge with tables, chairs, and a long counter.",
        "public_id": "01a117cd-df39-7770-8f67-c3c9c8a22e77",
        "storage_key": "property/6767906449167810/01a117cd-df39-7770-8f67-c3c9c8a22e77.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish community lounge, featuring comfortable seating, ample table space, and a sleek counter area.",
      "link": "",
      "alt_text": "Modern community lounge with tables, chairs, and a long counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c4bc520-214c-4c97-aad3-d1ff7e2d49c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-d859-70d9-b9ff-35cc96394c49.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table and foosball table",
        "public_id": "01a117cd-d859-70d9-b9ff-35cc96394c49",
        "storage_key": "property/6767906449167810/01a117cd-d859-70d9-b9ff-35cc96394c49.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy your downtime in our vibrant community lounge, featuring a pool table and foosball table for endless entertainment.",
      "link": "",
      "alt_text": "Community lounge with pool table and foosball table",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f8a4873-c68c-4d5a-9f16-18c849f55b9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-d81b-73f5-9f91-a0228721dd11.webp",
      "image_media": {
        "alt_text": "Lounge area with foosball table, pool table, and seating.",
        "public_id": "01a117cd-d81b-73f5-9f91-a0228721dd11",
        "storage_key": "property/6767906449167810/01a117cd-d81b-73f5-9f91-a0228721dd11.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy recreational activities in the community lounge, featuring a foosball table and a pool table, perfect for socializing and unwinding.",
      "link": "",
      "alt_text": "Lounge area with foosball table, pool table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e84febed-4b23-476c-be0b-624a3dc3135d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-ce14-74d9-85e0-2bbd87cadc17.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, foosball table, and seating area with a TV.",
        "public_id": "01a117cd-ce14-74d9-85e0-2bbd87cadc17",
        "storage_key": "property/6767906449167810/01a117cd-ce14-74d9-85e0-2bbd87cadc17.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our vibrant community lounge featuring a pool table, foosball, and a comfortable seating area perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Community lounge with a pool table, foosball table, and seating area with a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41eec32d-15fd-4441-a8c5-7433014cfc9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-cf21-72f9-8fa1-acc05fdc2ace.webp",
      "image_media": {
        "alt_text": "Modern fireplace with gray tile surround in a living room.",
        "public_id": "01a117cd-cf21-72f9-8fa1-acc05fdc2ace",
        "storage_key": "property/6767906449167810/01a117cd-cf21-72f9-8fa1-acc05fdc2ace.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy up by the modern gas fireplace, a beautiful centerpiece for your living space, featuring a sleek tile surround and realistic flames.",
      "link": "",
      "alt_text": "Modern fireplace with gray tile surround in a living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95df3ecd-1ab8-4837-86d5-538c4ac830ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-c909-769e-b318-3e9b7dcdaabb.webp",
      "image_media": {
        "alt_text": "Community room with a pool table and fireplace",
        "public_id": "01a117cd-c909-769e-b318-3e9b7dcdaabb",
        "storage_key": "property/6767906449167810/01a117cd-c909-769e-b318-3e9b7dcdaabb.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy a game of pool or relax by the fireplace in our stylish community room.",
      "link": "",
      "alt_text": "Community room with a pool table and fireplace",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b4f78b9-1b97-47a2-96be-c0d2685c245c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-c38e-752b-a0d5-71956e7bcae8.webp",
      "image_media": {
        "alt_text": "Modern apartment building hallway with bright lighting, orange accents, and glass entrance doors.",
        "public_id": "01a117cd-c38e-752b-a0d5-71956e7bcae8",
        "storage_key": "property/6767906449167810/01a117cd-c38e-752b-a0d5-71956e7bcae8.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Step into a welcoming and well-lit hallway, featuring modern design elements, vibrant orange accents, and a spacious glass entrance, creating an inviting atmosphere.",
      "link": "",
      "alt_text": "Modern apartment building hallway with bright lighting, orange accents, and glass entrance doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eca02070-acba-4e21-a0b6-64afe8463b40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-c1da-776a-8266-997dee1d9f88.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio and weight machines, dumbbells, and large windows.",
        "public_id": "01a117cd-c1da-776a-8266-997dee1d9f88",
        "storage_key": "property/6767906449167810/01a117cd-c1da-776a-8266-997dee1d9f88.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Modern apartment gym with cardio and weight machines, dumbbells, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1aa5aa13-87ab-487c-8c0e-f55ce15398f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-bb3b-7757-9d76-7a02c42757b4.webp",
      "image_media": {
        "alt_text": "Pet grooming station with recycling and garbage bins.",
        "public_id": "01a117cd-bb3b-7757-9d76-7a02c42757b4",
        "storage_key": "property/6767906449167810/01a117cd-bb3b-7757-9d76-7a02c42757b4.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Convenient pet grooming station with dedicated recycling and garbage disposal areas for resident convenience.",
      "link": "",
      "alt_text": "Pet grooming station with recycling and garbage bins.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78452196-6e66-449a-a5b0-b17ba344be40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-b893-70ac-a61a-0652996dfb4d.webp",
      "image_media": {
        "alt_text": "Pet grooming station with a stainless steel tub and faucet",
        "public_id": "01a117cd-b893-70ac-a61a-0652996dfb4d",
        "storage_key": "property/6767906449167810/01a117cd-b893-70ac-a61a-0652996dfb4d.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Convenient pet grooming station with a spacious stainless steel tub and easy-access ramp for your furry friends.",
      "link": "",
      "alt_text": "Pet grooming station with a stainless steel tub and faucet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14a9a071-dfd2-4ae8-928e-16290854c644",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-b46d-75a8-b9de-d5e11edb5d8f.webp",
      "image_media": {
        "alt_text": "Modern mailroom with smart package lockers and mailboxes",
        "public_id": "01a117cd-b46d-75a8-b9de-d5e11edb5d8f",
        "storage_key": "property/6767906449167810/01a117cd-b46d-75a8-b9de-d5e11edb5d8f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Secure and convenient package lockers and traditional mailboxes in a bright, modern community mailroom.",
      "link": "",
      "alt_text": "Modern mailroom with smart package lockers and mailboxes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_06b4f6ab-1f2a-4997-b54c-5f14349ac093",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-b2ba-7318-bbda-03637cf2c61f.webp",
      "image_media": {
        "alt_text": "Hallway with apartment doors and modern decor",
        "public_id": "01a117cd-b2ba-7318-bbda-03637cf2c61f",
        "storage_key": "property/6767906449167810/01a117cd-b2ba-7318-bbda-03637cf2c61f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover the stylish and modern hallways of our community, featuring sleek apartment doors and vibrant architectural details.",
      "link": "",
      "alt_text": "Hallway with apartment doors and modern decor",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6b2654e-22c3-4a85-9d36-52928e80bbff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-a9b4-7198-832b-1ed0f6b8505a.webp",
      "image_media": {
        "alt_text": "Secure indoor bicycle storage area with wall-mounted racks and multiple bikes.",
        "public_id": "01a117cd-a9b4-7198-832b-1ed0f6b8505a",
        "storage_key": "property/6767906449167810/01a117cd-a9b4-7198-832b-1ed0f6b8505a.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Secure and convenient indoor bicycle storage for residents, featuring ample rack space to keep your bike safe and accessible.",
      "link": "",
      "alt_text": "Secure indoor bicycle storage area with wall-mounted racks and multiple bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf0373eb-e1a7-4a0b-8810-596abf74c985",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-a232-735e-868a-3b6764e0c303.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weight machines, and large exercise balls.",
        "public_id": "01a117cd-a232-735e-868a-3b6764e0c303",
        "storage_key": "property/6767906449167810/01a117cd-a232-735e-868a-3b6764e0c303.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Modern gym with cardio machines, weight machines, and large exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4631a83e-957d-4399-8d5b-6ab12b3a01be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-9cb9-7167-b3c2-8d458513089a.webp",
      "image_media": {
        "alt_text": "Modern gym with free weights, weight machines, stability balls, and treadmills.",
        "public_id": "01a117cd-9cb9-7167-b3c2-8d458513089a",
        "storage_key": "property/6767906449167810/01a117cd-9cb9-7167-b3c2-8d458513089a.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring top-tier cardio and weight training equipment.",
      "link": "",
      "alt_text": "Modern gym with free weights, weight machines, stability balls, and treadmills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29569c5d-0ba0-4302-acaf-601f744bbd6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-9757-75a8-8cde-5ed5be76020b.webp",
      "image_media": {
        "alt_text": "Modern laundry room with dark wood cabinets and white subway tile backsplash.",
        "public_id": "01a117cd-9757-75a8-8cde-5ed5be76020b",
        "storage_key": "property/6767906449167810/01a117cd-9757-75a8-8cde-5ed5be76020b.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious laundry room featuring sleek dark wood cabinetry, a stainless steel refrigerator, and a white subway tile backsplash. Includes a stacked washer and dryer set.",
      "link": "",
      "alt_text": "Modern laundry room with dark wood cabinets and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54cd30f6-8c8c-4084-b1e3-749d7d62bd37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-94f5-73b0-944d-35037bc12e5d.webp",
      "image_media": {
        "alt_text": "Modern laundry room with stacked washer and dryer, sleek cabinetry, and ample storage space.",
        "public_id": "01a117cd-94f5-73b0-944d-35037bc12e5d",
        "storage_key": "property/6767906449167810/01a117cd-94f5-73b0-944d-35037bc12e5d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit laundry room featuring a washer and dryer, sleek cabinetry, and integrated storage solutions for a tidy and functional space.",
      "link": "",
      "alt_text": "Modern laundry room with stacked washer and dryer, sleek cabinetry, and ample storage space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_497186e4-5441-49ae-b112-a2a126e4452b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-886a-702b-81a3-51b6d915eade.webp",
      "image_media": {
        "alt_text": "Interior hallway leading to a kitchen and bathroom with a shower curtain.",
        "public_id": "01a117cd-886a-702b-81a3-51b6d915eade",
        "storage_key": "property/6767906449167810/01a117cd-886a-702b-81a3-51b6d915eade.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "View of a hallway inside an apartment, showing access to a bathroom with a shower curtain and a glimpse of the kitchen area with a dining table.",
      "link": "",
      "alt_text": "Interior hallway leading to a kitchen and bathroom with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_80f07338-32df-4e16-925c-ad46309799eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-8488-723e-918d-249b0a479751.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a floating vanity, toilet, and bathtub with a shower curtain.",
        "public_id": "01a117cd-8488-723e-918d-249b0a479751",
        "storage_key": "property/6767906449167810/01a117cd-8488-723e-918d-249b0a479751.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our modern bathrooms. Featuring sleek vanities, elegant fixtures, and a relaxing bathtub, perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with a floating vanity, toilet, and bathtub with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b98063d-932b-4940-a212-c21a153cbf99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-8560-75d3-843a-1e2a4e32dc8d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with a striped curtain.",
        "public_id": "01a117cd-8560-75d3-843a-1e2a4e32dc8d",
        "storage_key": "property/6767906449167810/01a117cd-8560-75d3-843a-1e2a4e32dc8d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bathroom, featuring a spacious vanity, modern fixtures, and a tranquil shower space.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7d91f94-fa7c-4f41-9fe3-cdbe5dcddfff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-8269-74a8-b7df-b6e42cd197d9.webp",
      "image_media": {
        "alt_text": "Interior hallway with doors to bathroom and bedroom, view of kitchen and dining area.",
        "public_id": "01a117cd-8269-74a8-b7df-b6e42cd197d9",
        "storage_key": "property/6767906449167810/01a117cd-8269-74a8-b7df-b6e42cd197d9.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment hallway, leading to a well-appointed bathroom and a cozy bedroom. The open layout flows into a modern kitchen and a bright dining area, perfect for everyday living.",
      "link": "",
      "alt_text": "Interior hallway with doors to bathroom and bedroom, view of kitchen and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_79ca890f-b056-4755-baab-b1a40f58d08b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-7cc1-72ec-8f82-ec0a98988c7d.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a view into the bathroom.",
        "public_id": "01a117cd-7cc1-72ec-8f82-ec0a98988c7d",
        "storage_key": "property/6767906449167810/01a117cd-7cc1-72ec-8f82-ec0a98988c7d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Comfortable and stylish bedroom featuring a plush king-size bed, modern nightstands, and a well-appointed en-suite bathroom accessible through a sliding door.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a33e026-84d1-4d69-8f42-fe1895a97281",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-707e-7146-97d9-81d2eb411871.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and attached bathroom",
        "public_id": "01a117cd-707e-7146-97d9-81d2eb411871",
        "storage_key": "property/6767906449167810/01a117cd-707e-7146-97d9-81d2eb411871.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a plush bed, a mirrored closet, and an adjoining bathroom with a toilet and shower.",
      "link": "",
      "alt_text": "Bedroom with closet and attached bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67a7f332-af53-43f6-a125-92203c7ed5e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-6b90-702e-8ede-3f768f00b4d5.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed and nightstands, and a living area visible through sliding doors.",
        "public_id": "01a117cd-6b90-702e-8ede-3f768f00b4d5",
        "storage_key": "property/6767906449167810/01a117cd-6b90-702e-8ede-3f768f00b4d5.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, elegant nightstands, and mirrored closet doors. Enjoy the open-concept living and dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Bedroom with a bed and nightstands, and a living area visible through sliding doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_902b81a3-2256-4406-a9e0-7b2648795689",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-68fa-73bd-a4d7-4948acaced26.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with stainless steel refrigerator and cabinets, light wood floor, and window with a sky view.",
        "public_id": "01a117cd-68fa-73bd-a4d7-4948acaced26",
        "storage_key": "property/6767906449167810/01a117cd-68fa-73bd-a4d7-4948acaced26.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed apartment kitchen and dining area, featuring sleek stainless steel appliances, ample cabinet space, and a bright, airy atmosphere with a view of the sky.",
      "link": "",
      "alt_text": "Kitchen and dining area with stainless steel refrigerator and cabinets, light wood floor, and window with a sky view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa2c4ee1-a99b-41eb-aa32-2a2e32ae38f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-67a5-75cc-8aad-c7869a280b23.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and nightstand, leading to a living room and balcony.",
        "public_id": "01a117cd-67a5-75cc-8aad-c7869a280b23",
        "storage_key": "property/6767906449167810/01a117cd-67a5-75cc-8aad-c7869a280b23.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a comfortable queen-size bed, modern nightstand, and access to a bright living area and private balcony.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and nightstand, leading to a living room and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6006a6e5-e1a3-4357-a874-3ef6895f6d1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-5f44-703b-8fc7-7ba011876498.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets and white subway tile backsplash.",
        "public_id": "01a117cd-5f44-703b-8fc7-7ba011876498",
        "storage_key": "property/6767906449167810/01a117cd-5f44-703b-8fc7-7ba011876498.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Explore this sleek, modern kitchen featuring dark wood cabinetry, a crisp white subway tile backsplash, and stainless steel appliances. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a77f022-24a4-40f1-8f1e-e82422d94bad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-59aa-745d-9292-c017d6da4082.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "01a117cd-59aa-745d-9292-c017d6da4082",
        "storage_key": "property/6767906449167810/01a117cd-59aa-745d-9292-c017d6da4082.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring dark wood cabinetry, a sleek microwave, a deep sink, and a modern stovetop. Perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_085d5998-b950-492b-ba8b-627668c9b677",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4fd6-73bd-961f-b987ecb88bac.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, white subway tile backsplash, stainless steel appliances, and a sleek faucet.",
        "public_id": "01a117cd-4fd6-73bd-961f-b987ecb88bac",
        "storage_key": "property/6767906449167810/01a117cd-4fd6-73bd-961f-b987ecb88bac.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Discover a stylish kitchen featuring dark wood cabinetry, a subway tile backsplash, and modern stainless steel appliances, perfect for culinary creations.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, white subway tile backsplash, stainless steel appliances, and a sleek faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f890f1a5-9125-4b57-be14-751c358829bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4f10-703f-8c6a-6a36e6ce951c.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with black cabinetry, stainless steel appliances, and a small desk area.",
        "public_id": "01a117cd-4f10-703f-8c6a-6a36e6ce951c",
        "storage_key": "property/6767906449167810/01a117cd-4f10-703f-8c6a-6a36e6ce951c.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Stylish and functional apartment kitchen featuring sleek black cabinets, a subway tile backsplash, and integrated stainless steel appliances. Includes a convenient desk space for work or study.",
      "link": "",
      "alt_text": "Modern apartment kitchen with black cabinetry, stainless steel appliances, and a small desk area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61bbe64d-1c24-4349-a8c2-862b8e9165b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4b43-70bc-b847-3e2f150170c7.webp",
      "image_media": {
        "alt_text": "Modern apartment interior with a dining table, chairs, and a kitchen with black cabinetry.",
        "public_id": "01a117cd-4b43-70bc-b847-3e2f150170c7",
        "storage_key": "property/6767906449167810/01a117cd-4b43-70bc-b847-3e2f150170c7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment featuring a chic dining area and a sleek, modern kitchen with black cabinets and subway tile backsplash. Perfect for entertaining or everyday living.",
      "link": "",
      "alt_text": "Modern apartment interior with a dining table, chairs, and a kitchen with black cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39b562f6-0814-4184-af21-2b5c338d4c38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4929-775f-b677-4f826c4f50df.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a view into the bedroom through glass sliding doors.",
        "public_id": "01a117cd-4929-775f-b677-4f826c4f50df",
        "storage_key": "property/6767906449167810/01a117cd-4929-775f-b677-4f826c4f50df.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Stylish living and dining space with contemporary decor, featuring a comfortable sofa, elegant dining table, and a view into the serene bedroom.",
      "link": "",
      "alt_text": "Modern living and dining area with a view into the bedroom through glass sliding doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1d02c3a-8c01-487d-b5d4-a3480ebed8dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-3c55-725f-aac7-8ebeaa165440.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with white sofa, coffee table, and dining set. Large windows offer exterior views.",
        "public_id": "01a117cd-3c55-725f-aac7-8ebeaa165440",
        "storage_key": "property/6767906449167810/01a117cd-3c55-725f-aac7-8ebeaa165440.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment featuring a spacious living and dining area, perfect for relaxing and entertaining. Large windows flood the space with natural light, offering pleasant exterior views.",
      "link": "",
      "alt_text": "Modern living and dining area with white sofa, coffee table, and dining set. Large windows offer exterior views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d4ca5088-8bbb-4fa2-9bb1-2f2a459eb3f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-39eb-756f-90fa-d7eba22119fb.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, foosball table, fireplace, seating area, and TV.",
        "public_id": "01a117cd-39eb-756f-90fa-d7eba22119fb",
        "storage_key": "property/6767906449167810/01a117cd-39eb-756f-90fa-d7eba22119fb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the spacious community lounge, perfect for socializing or unwinding. Features a pool table, foosball table, comfortable seating, and a modern fireplace.",
      "link": "",
      "alt_text": "Community lounge with pool table, foosball table, fireplace, seating area, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_655ebccb-44af-4d60-962f-29cb3607f2f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-3271-7689-98e7-e427aa458676.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, foosball table, fireplace, and lounge seating.",
        "public_id": "01a117cd-3271-7689-98e7-e427aa458676",
        "storage_key": "property/6767906449167810/01a117cd-3271-7689-98e7-e427aa458676.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and entertain in our vibrant community lounge, featuring a pool table, foosball, a cozy fireplace, and comfortable seating areas.",
      "link": "",
      "alt_text": "Community lounge with pool table, foosball table, fireplace, and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3661bda-7473-4767-995f-cee41331c6f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-2f68-732f-a851-5bc03d7347ab.webp",
      "image_media": {
        "alt_text": "Modern lounge area with pool table, foosball table, fireplace, and comfortable seating.",
        "public_id": "01a117cd-2f68-732f-a851-5bc03d7347ab",
        "storage_key": "property/6767906449167810/01a117cd-2f68-732f-a851-5bc03d7347ab.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and entertain in our stylish resident lounge, featuring a pool table, foosball, a cozy fireplace, and ample seating for socializing.",
      "link": "",
      "alt_text": "Modern lounge area with pool table, foosball table, fireplace, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1dde233f-e55c-4905-82c8-154e4926afa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-2c78-76e7-8c45-07becf048659.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, white subway tile backsplash, stainless steel appliances, and a doorway in the background.",
        "public_id": "01a117cd-2c78-76e7-8c45-07becf048659",
        "storage_key": "property/6767906449167810/01a117cd-2c78-76e7-8c45-07becf048659.webp",
        "width": 1319,
        "height": 879
      },
      "title": "Apartment",
      "description": "A sleek and contemporary kitchen featuring dark wood cabinetry, a white subway tile backsplash, and stainless steel appliances. This space seamlessly integrates cooking and living.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, white subway tile backsplash, stainless steel appliances, and a doorway in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bdc8d02f-f5a2-46c7-8a31-f669c157a33c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-1e48-71c8-9ea5-8d9ee2063d12.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, coffee table, and a bed visible through sliding glass doors.",
        "public_id": "01a117cd-1e48-71c8-9ea5-8d9ee2063d12",
        "storage_key": "property/6767906449167810/01a117cd-1e48-71c8-9ea5-8d9ee2063d12.webp",
        "width": 1318,
        "height": 879
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment featuring a comfortable living area, dining space, and a well-appointed bedroom, all bathed in natural light.",
      "link": "",
      "alt_text": "Modern living room with a white sofa, coffee table, and a bed visible through sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea59a64b-13aa-43ef-b09a-46325619c674",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-1c45-71fc-8ff8-4ed3a462b7c6.webp",
      "image_media": {
        "alt_text": "Modern open-concept kitchen and dining area with a sleek black kitchen island and white countertop.",
        "public_id": "01a117cd-1c45-71fc-8ff8-4ed3a462b7c6",
        "storage_key": "property/6767906449167810/01a117cd-1c45-71fc-8ff8-4ed3a462b7c6.webp",
        "width": 1320,
        "height": 879
      },
      "title": "Apartment",
      "description": "Experience sophisticated urban living in this stylish apartment, featuring a modern open-concept kitchen and dining area, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern open-concept kitchen and dining area with a sleek black kitchen island and white countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_82364973-7615-4687-81bd-4f51bc44514e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Donnelly Cafe",
      "poi_type": "Restaurants",
      "poi_address": "163 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-400e-75da-8a42-d7f3fa903dad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-400e-75da-8a42-d7f3fa903dad",
        "storage_key": "property/6767906449167810/01a117cc-400e-75da-8a42-d7f3fa903dad.webp",
        "width": 540,
        "height": 360
      },
      "poi_business_url": "http://www.donnellycafe.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16955368475259610549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donnelly-cafe",
      "poi_latitude": "43.1878177",
      "poi_longitude": "-81.4034606",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-494-6685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RXaKEXdLogRtaW0e8uRTes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4aaf9046-611e-4c45-b6e6-94871cff4715",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Thai Pad",
      "poi_type": "Restaurants",
      "poi_address": "175 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Local Thai restaurant serving generous portions of pad Thai and spring rolls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-3018-71dd-bc7c-64d6252a6edd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-3018-71dd-bc7c-64d6252a6edd",
        "storage_key": "property/6767906449167810/01a117ca-3018-71dd-bc7c-64d6252a6edd.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://thaipad.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369266648081324545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-pad",
      "poi_latitude": "43.188122",
      "poi_longitude": "-81.4039712",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-0404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1y10R7jdLogRAVox5BMJ548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_da8967be-b765-400a-a19e-77642014750e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Sunshine Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "168 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-44ed-769c-91b5-f202c0d3126d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-44ed-769c-91b5-f202c0d3126d",
        "storage_key": "property/6767906449167810/01a117cc-44ed-769c-91b5-f202c0d3126d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4468284646868476972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunshine-restaurant",
      "poi_latitude": "43.1881898",
      "poi_longitude": "-81.4035826",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-0676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAdCZSbjdLogRLGTtWzaJAj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_01d32e77-6897-4f8f-a85f-a55ae2abd489",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "New Orleans Pizza",
      "poi_type": "Restaurants",
      "poi_address": "166 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Pizza restaurant serving a variety of pizzas, wings, and savory side dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-410d-7009-9369-80e50a60f632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-410d-7009-9369-80e50a60f632",
        "storage_key": "property/6767906449167810/01a117cc-410d-7009-9369-80e50a60f632.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.neworleanspizza.com/ll/CA/Ontario/Lucan/166-Main-St_",
      "poi_directions_map_url": "https://maps.google.com/?cid=7025132237972139957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-orleans-pizza",
      "poi_latitude": "43.1881407",
      "poi_longitude": "-81.40339809999999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7yC2S7jdLogRtW95uIxIfmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_b5b628d8-a258-4d54-a358-37a08e7f1841",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Hometown Subs",
      "poi_type": "Restaurants",
      "poi_address": "174 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-47be-7088-97f1-85b76fa6291f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-47be-7088-97f1-85b76fa6291f",
        "storage_key": "property/6767906449167810/01a117cc-47be-7088-97f1-85b76fa6291f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clover.com/online-ordering/home-town-subs-lucan",
      "poi_directions_map_url": "https://maps.google.com/?cid=7489199668852737306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hometown-subs",
      "poi_latitude": "43.1883118",
      "poi_longitude": "-81.4038511",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 226-304-2320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3MX3F_dLogRGsXwWWv77mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_takeaway"
    },
    {
      "id": "custom_c275364f-ee07-4ed5-91b4-44712a01e957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Dessert First Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "200 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-44ea-7535-9845-cea8e53e20df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-44ea-7535-9845-cea8e53e20df",
        "storage_key": "property/6767906449167810/01a117cc-44ea-7535-9845-cea8e53e20df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100085190974251",
      "poi_directions_map_url": "https://maps.google.com/?cid=8948197522560774694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dessert-first-bakery-cafe",
      "poi_latitude": "43.1892691",
      "poi_longitude": "-81.40589720000001",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-671-8394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0JigHLdLogRJvJDuDxiLnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_df75beca-b78c-40d7-9eb7-ff6217ebc9e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "The Hub Roadhouse Lucan",
      "poi_type": "Restaurants",
      "poi_address": "269 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-410e-7615-8db7-311ebfb29b63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-410e-7615-8db7-311ebfb29b63",
        "storage_key": "property/6767906449167810/01a117cc-410e-7615-8db7-311ebfb29b63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thehubroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14786608624510625285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hub-roadhouse-lucan",
      "poi_latitude": "43.1911773",
      "poi_longitude": "-81.41177909999999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-868-6565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4cgbabdLogRBeaugDOWNM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e4813ed1-4bd8-436e-b390-ed0b596b1c72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Wilberforce Inn",
      "poi_type": "Restaurants",
      "poi_address": "161 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1937765382582437216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilberforce-inn",
      "poi_latitude": "43.1877979",
      "poi_longitude": "-81.4033334",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxkYs7ndLogRYAXgRllT5Bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_4725408e-6658-4cdf-b52f-a4b67ec52434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "McDonald's",
      "poi_type": "Restaurants",
      "poi_address": "355 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_long_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-40be-73d5-aa21-f2f76ffda466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-40be-73d5-aa21-f2f76ffda466",
        "storage_key": "property/6767906449167810/01a117cc-40be-73d5-aa21-f2f76ffda466.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mcdonalds.com/ca/en-ca/restaurant-locator.html?y_source=1_MTA0Njk4OTc4NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10282165377078313790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcdonalds",
      "poi_latitude": "43.1935552",
      "poi_longitude": "-81.4165426",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-227-0608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUsnYADdLogRPsOS5u6WsY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6689beac-7376-4402-9555-433811955b3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "barBURRITO",
      "poi_type": "Restaurants",
      "poi_address": "315 Richmond St unit 373, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Tex-Mex restaurant serving fresh burritos and burrito bowls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-3035-7529-9cd0-39afea5b7086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-3035-7529-9cd0-39afea5b7086",
        "storage_key": "property/6767906449167810/01a117ca-3035-7529-9cd0-39afea5b7086.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.barburrito.ca/location/lucan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=915288126436682991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barburrito",
      "poi_latitude": "43.1936554",
      "poi_longitude": "-81.4169379",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-227-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7WXiRFvdLogR7yxkm7PBsww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_8e8e3f15-f9ef-476a-a845-a0104bad190b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Domino's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "377 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Delivery, carryout & dine-in chain offering a wide range of pizzas, plus a variety of other dishes & sides.",
      "poi_long_description": "Delivery, carryout & dine-in chain offering a wide range of pizzas, plus a variety of other dishes & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-410d-7009-9369-7f96c7fb6396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-410d-7009-9369-7f96c7fb6396",
        "storage_key": "property/6767906449167810/01a117cc-410d-7009-9369-7f96c7fb6396.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://pizza.dominos.ca/lucan-ontario-39059/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13694816470373119845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominos-pizza",
      "poi_latitude": "43.1935515",
      "poi_longitude": "-81.4170304",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-227-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3V6fofdLogRZTfChAXDDb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_delivery"
    },
    {
      "id": "custom_616fb6fe-4202-4468-9684-2d618e981dc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Subway",
      "poi_type": "Restaurants",
      "poi_address": "391 Main St A-1, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_long_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-2c51-749d-a5b7-068dbc2b3e10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-2c51-749d-a5b7-068dbc2b3e10",
        "storage_key": "property/6767906449167810/01a117ca-2c51-749d-a5b7-068dbc2b3e10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.subway.com/en-CA?utm_source=yext-other&utm_medium=local&utm_term=acq&utm_content=74587&utm_campaign=evergreen-2020&y_source=1_MjAzMTUxNDk2NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4366038266829776030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "subway",
      "poi_latitude": "43.1940225",
      "poi_longitude": "-81.4178799",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-227-0112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfS6ebzfdLogRnqQm4qtIlzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_6cd1f732-d983-411b-aef5-4e816ef1c2cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Tim Hortons",
      "poi_type": "Restaurants",
      "poi_address": "33389 Richmond St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Canadian chain for signature premium-blend coffee, plus light fare, pastries & breakfast sandwiches.",
      "poi_long_description": "Canadian chain for signature premium-blend coffee, plus light fare, pastries & breakfast sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-44a1-7527-9386-8178d4b621d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-44a1-7527-9386-8178d4b621d8",
        "storage_key": "property/6767906449167810/01a117cc-44a1-7527-9386-8178d4b621d8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://locations.timhortons.ca/en/on/lucan/33389-richmond-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312607645870430187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tim-hortons",
      "poi_latitude": "43.1844817",
      "poi_longitude": "-81.39657319999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-227-0129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6b7f-756c-b836-870dcb39ea27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6b7f-756c-b836-870dcb39ea27",
        "storage_key": "property/6767906449167810/01a117cc-6b7f-756c-b836-870dcb39ea27.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJX4y4WmndLogR65dZXBq_-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_380b85e9-b81f-43d0-a28f-c4dbf0380b90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "North Star Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "14368 Elginfield Rd, London, ON N0M 2J0, Canada",
      "poi_short_description": "Welcoming family restaurant serving hearty, home-cooked meals and large portions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-2c79-7579-848a-8dcdf2dd1388.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-2c79-7579-848a-8dcdf2dd1388",
        "storage_key": "property/6767906449167810/01a117ca-2c79-7579-848a-8dcdf2dd1388.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thenorthstarrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1572222762033325381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-star-restaurant",
      "poi_latitude": "43.167852499999995",
      "poi_longitude": "-81.35282509999999",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 519-227-4036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbp0ffbdLogRRaXHpkWo0RU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1dd8a6c5-53b0-47d5-8a17-6351f0283580",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Malibu Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "36316 Richmond St, Centralia, ON N0M 1K0, Canada",
      "poi_short_description": "Family-operated diner serving hearty home-cooked meals and generous portions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-44a4-7218-a09e-e088df72af09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-44a4-7218-a09e-e088df72af09",
        "storage_key": "property/6767906449167810/01a117cc-44a4-7218-a09e-e088df72af09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8645035306554711833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malibu-restaurant",
      "poi_latitude": "43.2887187",
      "poi_longitude": "-81.4682447",
      "poi_miles_from_property": "13.8",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 519-228-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45af-73ef-91a5-ed15430eb2df",
        "storage_key": "property/6767906449167810/01a117ca-45af-73ef-91a5-ed15430eb2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-lLs5fZLogRGV_n1c5V-Xc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_13a59f63-f6ee-4673-8926-363cf763b1ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Foodland Lucan",
      "poi_type": "Shopping & Retail",
      "poi_address": "315 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Full-service neighborhood supermarket featuring farm-fresh produce, a butcher shop, and a home-style bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-2e26-758d-8ca6-0de92678d1d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-2e26-758d-8ca6-0de92678d1d9",
        "storage_key": "property/6767906449167810/01a117ca-2e26-758d-8ca6-0de92678d1d9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://foodland.ca/stores/foodland-lucan/?utm_source=G&utm_medium=lpm&utm_campaign=Sobeys",
      "poi_directions_map_url": "https://maps.google.com/?cid=16136470063520716702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foodland-lucan",
      "poi_latitude": "43.192945599999994",
      "poi_longitude": "-81.4172158",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-227-1338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4599-73ff-9ceb-8155bbcff074.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-4599-73ff-9ceb-8155bbcff074",
        "storage_key": "property/6767906449167810/01a117ca-4599-73ff-9ceb-8155bbcff074.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQxDPrjdLogRnpfgMAdC8N8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_202019cb-5295-4c70-80b4-a0b48ac838a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Drug Mart",
      "poi_type": "Health and Wellness",
      "poi_address": "180 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3455202253471498000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-drug-mart",
      "poi_latitude": "43.1884248",
      "poi_longitude": "-81.4041355",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-4792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6b71-73a8-8628-b7908ffef6f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6b71-73a8-8628-b7908ffef6f7",
        "storage_key": "property/6767906449167810/01a117cc-6b71-73a8-8628-b7908ffef6f7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ybrOLjdLogRED9MoSRY8y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_bdf136f4-dd53-428a-8c66-03430b4eb0e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "IDA LUCAN CARE PHARMACY ( I.D.A ) LUCAN DRUG STORE , PHARMACY IN LUCAN",
      "poi_type": "Health and Wellness",
      "poi_address": "333 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-493d-712e-b854-0cb6fb3e7c7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-493d-712e-b854-0cb6fb3e7c7d",
        "storage_key": "property/6767906449167810/01a117cc-493d-712e-b854-0cb6fb3e7c7d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.guardian-ida-remedysrx.ca/en/ontario/lucan/lucan-care-pharmacy-7065762",
      "poi_directions_map_url": "https://maps.google.com/?cid=12064572375899501511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ida-lucan-care-pharmacy--ida--lucan-drug-store--pharmacy-in-lucan",
      "poi_latitude": "43.192572299999995",
      "poi_longitude": "-81.41632829999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 226-593-0143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6b71-73a8-8628-b7908ffef6f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6b71-73a8-8628-b7908ffef6f7",
        "storage_key": "property/6767906449167810/01a117cc-6b71-73a8-8628-b7908ffef6f7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ37sHCVHdLogRx_N6sKf4bac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_217370ff-d4ff-4a44-9cf5-d9b4fcc22429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Convenience",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5049587566340843954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-convenience",
      "poi_latitude": "43.1857956",
      "poi_longitude": "-81.3978411",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-227-1474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ98snoLvdLogRsqn5QSO9E0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_35092efa-e6b7-47d6-8c9c-ab3d4c3463bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lankin's Variety",
      "poi_type": "Shopping & Retail",
      "poi_address": "199 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6307830414379827687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lankins-variety",
      "poi_latitude": "43.1891036",
      "poi_longitude": "-81.406422",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-4754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6b7e-70a9-b764-8583e569f893.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6b7e-70a9-b764-8583e569f893",
        "storage_key": "property/6767906449167810/01a117cc-6b7e-70a9-b764-8583e569f893.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJWwy8-8fdLogR58GDcFfqiVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_6cd79253-a202-4080-838f-a50fb8ac906d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "LCBO",
      "poi_type": "Shopping & Retail",
      "poi_address": "196 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-490a-7723-bc4f-8a4ca4bd6afe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-490a-7723-bc4f-8a4ca4bd6afe",
        "storage_key": "property/6767906449167810/01a117cc-490a-7723-bc4f-8a4ca4bd6afe.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://www.lcbo.com/en/stores/main-market-264?utm_medium=location&utm_source=google&utm_campaign=store264&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=17237153018870238698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lcbo",
      "poi_latitude": "43.1891065",
      "poi_longitude": "-81.40541569999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-4279",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaal5D7jdLogR6g3QJFirNu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_13f3fd06-cd16-4fce-ad89-9a3f4797bc5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Pet Valu",
      "poi_type": "Shopping & Retail",
      "poi_address": "325 Main St #3B, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Retail chain carrying food, supplies, toys & other products for pets such as dogs, cats & reptiles.",
      "poi_long_description": "Retail chain carrying food, supplies, toys & other products for pets such as dogs, cats & reptiles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-4b2e-742d-8e6a-0f3bc5da006f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-4b2e-742d-8e6a-0f3bc5da006f",
        "storage_key": "property/6767906449167810/01a117cc-4b2e-742d-8e6a-0f3bc5da006f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://store.petvalu.ca/location/2431/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4916515025379289044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pet-valu",
      "poi_latitude": "43.192667199999995",
      "poi_longitude": "-81.4166572",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-227-0669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEc5vdCjdLogR1Gea5F34OkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_83d80f13-12f9-46aa-b780-1d78c6cbfcf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Dollarama",
      "poi_type": "Shopping & Retail",
      "poi_address": "The Glenns Shopping Centre, 315 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.dollarama.com/en-CA/locations/on/lucan-315-main-st?utm_source=G&utm_medium=LPM&utm_campaign=Dollarama",
      "poi_directions_map_url": "https://maps.google.com/?cid=6938226915054767702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollarama",
      "poi_latitude": "43.1927721",
      "poi_longitude": "-81.41674809999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 888-365-4266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO6pfkbDdLogRVs7kcp6ISWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_0e94abd6-f93c-41d1-9169-59a91226dfbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Quickie Convenience Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "33406 Richmond St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-4a83-7361-b157-d93420260b38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-4a83-7361-b157-d93420260b38",
        "storage_key": "property/6767906449167810/01a117cc-4a83-7361-b157-d93420260b38.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://macewen.ca/retail/find-a-macewen/macewen-quickie-lucan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12638107269095111139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quickie-convenience-store",
      "poi_latitude": "43.1852679",
      "poi_longitude": "-81.396745",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-227-0059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6b7e-70a9-b764-8583e569f893.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6b7e-70a9-b764-8583e569f893",
        "storage_key": "property/6767906449167810/01a117cc-6b7e-70a9-b764-8583e569f893.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJo4z5UGndLogR4zmyB5qTY68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_86f6bd95-98d9-4ffe-aca1-08ac11e7a5ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "The Lucan Local",
      "poi_type": "Shopping & Retail",
      "poi_address": "152 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-4a15-77ca-875d-95e1ab00a502.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-4a15-77ca-875d-95e1ab00a502",
        "storage_key": "property/6767906449167810/01a117cc-4a15-77ca-875d-95e1ab00a502.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.thelucanlocal.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6710077699079396956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-lucan-local",
      "poi_latitude": "43.1877297",
      "poi_longitude": "-81.40241929999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-281-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl4E7QYbdLogRXN7lpB38Hl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_ad0e5cfc-f1a3-47f0-82da-7038844c09ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Wilberforce Elementary School",
      "poi_type": "Education",
      "poi_address": "340 Beech St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-4d8f-705d-807e-35184f11d8fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-4d8f-705d-807e-35184f11d8fe",
        "storage_key": "property/6767906449167810/01a117cc-4d8f-705d-807e-35184f11d8fe.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://www.tvdsb.ca/wilberforce",
      "poi_directions_map_url": "https://maps.google.com/?cid=16196099284394462116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilberforce-elementary-school",
      "poi_latitude": "43.1951828",
      "poi_longitude": "-81.4026947",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-227-2185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4-RhfrbdLogRpEtKEX0axOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a10f02c6-1c60-4bad-9dbd-db89682fd328",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "St. Patrick's Catholic Elementary School",
      "poi_type": "Education",
      "poi_address": "33654 Roman Line, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pal.ldcsb.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10432301990642652488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-patricks-catholic-elementary-school",
      "poi_latitude": "43.174858",
      "poi_longitude": "-81.3693618",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-660-2789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWa6MVmzdLogRSBXbRWP7xpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_48845cbb-bab4-4788-a44f-8ff885b9b739",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Ymca Of Lucan Child Care",
      "poi_type": "Education",
      "poi_address": "Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ymcaswo.ca/child-care/lucan",
      "poi_directions_map_url": "https://maps.google.com/?cid=8546357282772381993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-of-lucan-child-care",
      "poi_latitude": "43.19129590000001",
      "poi_longitude": "-81.4112368",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-907-0042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE6B9ysjdLogRKXE4C6vCmnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a41cc52d-4e05-45bb-8b68-6262cbd8578c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Library",
      "poi_type": "Education",
      "poi_address": "270 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-2fd5-7438-8635-d897e6020f88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-2fd5-7438-8635-d897e6020f88",
        "storage_key": "property/6767906449167810/01a117ca-2fd5-7438-8635-d897e6020f88.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://library.middlesex.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16761607704563049195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-library",
      "poi_latitude": "43.1923763",
      "poi_longitude": "-81.4122986",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-4682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4598-7378-aba5-74d62235a89f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-4598-7378-aba5-74d62235a89f",
        "storage_key": "property/6767906449167810/01a117ca-4598-7378-aba5-74d62235a89f.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJrecyyMjdLogR62LuhmYxneg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7295fb13-dd89-42cf-9f7d-f0106bac25c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "North Middlesex District High School",
      "poi_type": "Education",
      "poi_address": "100 Parkhill Main St, Parkhill, ON N0M 2K0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tvdsb.ca/nmdhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=15105502880477582640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-middlesex-district-high-school",
      "poi_latitude": "43.153832",
      "poi_longitude": "-81.6855625",
      "poi_miles_from_property": "29.4",
      "poi_walking_minutes": "6 hours 30 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 519-294-1128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK4PLPvvZKIgRMJWBYNaGodE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4d27931c-0ad2-46c6-bab8-e14fdf1cd72a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Parkhill West Williams Public School",
      "poi_type": "Education",
      "poi_address": "204 McLeod St, Parkhill, ON N0M 2K0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tvdsb.ca/parkhillwestwilliams",
      "poi_directions_map_url": "https://maps.google.com/?cid=17736903265328782052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkhill-west-williams-public-school",
      "poi_latitude": "43.1572937",
      "poi_longitude": "-81.68762199999999",
      "poi_miles_from_property": "29.2",
      "poi_walking_minutes": "6 hours 28 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 519-294-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc9uA7tkZL4gR5FpjsYsjJvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0e5018b1-872d-4c21-bf2e-3559bdad3e1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Fanshawe College",
      "poi_type": "Education",
      "poi_address": "1001 Fanshawe College Blvd, London, ON N5Y 5R6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-4c7e-70f2-a1b8-58206d753c44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-4c7e-70f2-a1b8-58206d753c44",
        "storage_key": "property/6767906449167810/01a117cc-4c7e-70f2-a1b8-58206d753c44.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.fanshawec.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12667187768978635348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fanshawe-college",
      "poi_latitude": "43.0129902",
      "poi_longitude": "-81.19942089999999",
      "poi_miles_from_property": "31.2",
      "poi_walking_minutes": "7 hours 2 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnx4-sw3tLogRVPokiSnkyq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3abe12a9-0db1-4a22-b849-fc6f62457b28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Area Heritage and Donnelly Museum",
      "poi_type": "Entertainment",
      "poi_address": "171 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Informative regional history museum featuring extensive Donnelly family artifacts and historical exhibits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-323e-75e9-b224-059b6da4df18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-323e-75e9-b224-059b6da4df18",
        "storage_key": "property/6767906449167810/01a117ca-323e-75e9-b224-059b6da4df18.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.donnellymuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13692090727669446415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-area-heritage-and-donnelly-museum",
      "poi_latitude": "43.188026",
      "poi_longitude": "-81.40378299999999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-0756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4587-706f-9fb8-61810c26c3fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-4587-706f-9fb8-61810c26c3fd",
        "storage_key": "property/6767906449167810/01a117ca-4587-706f-9fb8-61810c26c3fd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1-2SLjdLogRDzcoF_kTBL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e7d3f318-aacb-438b-a094-65fff06a03c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Community Memorial Centre",
      "poi_type": "Entertainment",
      "poi_address": "263 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "Versatile community arena featuring ice facilities, a gymnasium, and multipurpose event spaces.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-32ec-71ce-ba16-2a179b6ec3d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-32ec-71ce-ba16-2a179b6ec3d8",
        "storage_key": "property/6767906449167810/01a117ca-32ec-71ce-ba16-2a179b6ec3d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lucanbiddulph.on.ca/community-services/lucan-biddulph-community-memorial-centre",
      "poi_directions_map_url": "https://maps.google.com/?cid=13405309527179739694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-community-memorial-centre",
      "poi_latitude": "43.1909463",
      "poi_longitude": "-81.4111446",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-227-4442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45b0-75a8-8a8b-16bdd52e106f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45b0-75a8-8a8b-16bdd52e106f",
        "storage_key": "property/6767906449167810/01a117ca-45b0-75a8-8a8b-16bdd52e106f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJE_e7ycjdLogRLkK1l_05Cbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_6bb4fdd0-1c3f-45e8-848e-40af0384efed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Elm Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Elm St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11217884775538827455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elm-street-park",
      "poi_latitude": "43.184657699999995",
      "poi_longitude": "-81.40128150000001",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45ac-71ed-a712-84ae8cff4294",
        "storage_key": "property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____TLndLogRvyBBucTurZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d4972227-df77-4ffd-9185-1eb24f2e933a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "The Mustang Drive-In",
      "poi_type": "Entertainment",
      "poi_address": "2551 Wilton Grove Rd, London, ON N6N 1M7, Canada",
      "poi_short_description": "Dog-friendly drive-in showing new movies in classic digs with a snack bar & a playground.",
      "poi_long_description": "Dog-friendly drive-in showing new movies in classic digs with a snack bar & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5005-77b7-a6d5-b2c5d3fdb3ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5005-77b7-a6d5-b2c5d3fdb3ad",
        "storage_key": "property/6767906449167810/01a117cc-5005-77b7-a6d5-b2c5d3fdb3ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mustangdrive-in.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929147370024228974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mustang-drive-in",
      "poi_latitude": "42.9348945",
      "poi_longitude": "-81.1054631",
      "poi_miles_from_property": "43.1",
      "poi_walking_minutes": "9 hours 45 mins",
      "poi_biking_minutes": "2 hours 33 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6b7f-756c-b836-835a00fbc6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6b7f-756c-b836-835a00fbc6d7",
        "storage_key": "property/6767906449167810/01a117cc-6b7f-756c-b836-835a00fbc6d7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJt7rnlUiMLogRblg8ex6QSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e71e08ea-8e1e-40ce-9e97-28d9f93a821d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Grand Theatre",
      "poi_type": "Entertainment",
      "poi_address": "471 Richmond St, London, ON N6A 3E4, Canada",
      "poi_short_description": "Plays & musicals staged in a historic building dating to 1901 with a proscenium arch & original art.",
      "poi_long_description": "Plays & musicals staged in a historic building dating to 1901 with a proscenium arch & original art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-50be-75f4-bc6b-83eb09e1a654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-50be-75f4-bc6b-83eb09e1a654",
        "storage_key": "property/6767906449167810/01a117cc-50be-75f4-bc6b-83eb09e1a654.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.grandtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14464745647868561466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-theatre",
      "poi_latitude": "42.9859214",
      "poi_longitude": "-81.2508205",
      "poi_miles_from_property": "27.7",
      "poi_walking_minutes": "6 hours 14 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 519-672-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6ba3-74bf-b17c-b6774ca8e250.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6ba3-74bf-b17c-b6774ca8e250",
        "storage_key": "property/6767906449167810/01a117cc-6ba3-74bf-b17c-b6774ca8e250.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0hP-ZiSLogROkiVe4cZvcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_07c2da03-f8d3-46f1-9707-c689e18d35a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Fanshawe Pioneer Village",
      "poi_type": "Entertainment",
      "poi_address": "Spriet Family Visitor Centre, inside of, 1424 Clarke Rd, London, ON N5X 4A1, Canada",
      "poi_short_description": "Recreation of a pioneer village with costumed interpreters, hands-on activities & a general store.",
      "poi_long_description": "Recreation of a pioneer village with costumed interpreters, hands-on activities & a general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-4f98-76dd-8db6-4bac78fc4baa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-4f98-76dd-8db6-4bac78fc4baa",
        "storage_key": "property/6767906449167810/01a117cc-4f98-76dd-8db6-4bac78fc4baa.webp",
        "width": 792,
        "height": 789
      },
      "poi_business_url": "http://www.fanshawepioneervillage.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6561518808577832505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fanshawe-pioneer-village",
      "poi_latitude": "43.0553469",
      "poi_longitude": "-81.18170769999999",
      "poi_miles_from_property": "31",
      "poi_walking_minutes": "6 hours 56 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 519-457-1296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4587-706f-9fb8-61810c26c3fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-4587-706f-9fb8-61810c26c3fd",
        "storage_key": "property/6767906449167810/01a117ca-4587-706f-9fb8-61810c26c3fd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZ6Cn-bsLogROXZTjJcyD1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4b0cd7d7-d5aa-486b-807f-e304d36c4ce6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Museum London",
      "poi_type": "Entertainment",
      "poi_address": "421 Ridout St N, London, ON N6A 5H4, Canada",
      "poi_short_description": "Established in 1940, this museum features exhibits focused on regional art, history & culture.",
      "poi_long_description": "Established in 1940, this museum features exhibits focused on regional art, history & culture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-52fb-70cd-b88b-3961a971e49d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-52fb-70cd-b88b-3961a971e49d",
        "storage_key": "property/6767906449167810/01a117cc-52fb-70cd-b88b-3961a971e49d.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "http://museumlondon.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15410617961493557229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-london",
      "poi_latitude": "42.9825817",
      "poi_longitude": "-81.2550668",
      "poi_miles_from_property": "28.3",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 519-661-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4587-706f-9fb8-61810c26c3fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-4587-706f-9fb8-61810c26c3fd",
        "storage_key": "property/6767906449167810/01a117ca-4587-706f-9fb8-61810c26c3fd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2VM8q_fxLogR7e8TFGOD3dU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7044a6e9-ebc0-4120-8aec-8b67baf43b79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Covent Garden Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "130 King St, London, ON N6A 1C5, Canada",
      "poi_short_description": "Large indoor market since 1845 with a bi-weekly outdoor farmers' market & 20+ restaurants.",
      "poi_long_description": "Large indoor market since 1845 with a bi-weekly outdoor farmers' market & 20+ restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-511f-743b-aafe-d629bd35c5a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-511f-743b-aafe-d629bd35c5a2",
        "storage_key": "property/6767906449167810/01a117cc-511f-743b-aafe-d629bd35c5a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coventmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13260531597251818981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "covent-garden-market",
      "poi_latitude": "42.9828131",
      "poi_longitude": "-81.2503452",
      "poi_miles_from_property": "28.1",
      "poi_walking_minutes": "6 hours 19 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 519-439-3921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8a8sqh3yLogR5bUJ-zrfBrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_49fe9c80-4567-4ac9-9d36-b9602177b555",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Strathroy Middlesex General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "395 Carrie St, Strathroy, ON N7G 3J4, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5637-723f-8e2b-34330faae347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5637-723f-8e2b-34330faae347",
        "storage_key": "property/6767906449167810/01a117cc-5637-723f-8e2b-34330faae347.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.mhalliance.on.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11545446508357003847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strathroy-middlesex-general-hospital",
      "poi_latitude": "42.9610791",
      "poi_longitude": "-81.63382229999999",
      "poi_miles_from_property": "37.6",
      "poi_walking_minutes": "8 hours 23 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 519-245-5295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6baa-7378-b91f-68b4d8a98962",
        "storage_key": "property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJcX0bijkEL4gRR6rkz22qOaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e48207b2-83ad-4baf-bfdb-c7fb388dc994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Southwest Middlesex Health Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "22262 Mill Rd, Mount Brydges, ON N0L 1W0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://smhc.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17121881017314171016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-middlesex-health-centre",
      "poi_latitude": "42.8982192",
      "poi_longitude": "-81.4708646",
      "poi_miles_from_property": "41.1",
      "poi_walking_minutes": "9 hours 11 mins",
      "poi_biking_minutes": "2 hours 27 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 519-264-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8xCtk3-LogRiNiD0xEkne0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ce6ca6a5-da4f-4710-88bd-90ce4fc2fb34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Healthcare Collaborative",
      "poi_type": "Health and Wellness",
      "poi_address": "170 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-542f-704e-b392-a8da27697786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-542f-704e-b392-a8da27697786",
        "storage_key": "property/6767906449167810/01a117cc-542f-704e-b392-a8da27697786.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.lucanhealthcollab.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17654807764388300899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-healthcare-collaborative",
      "poi_latitude": "43.1882251",
      "poi_longitude": "-81.40368149999999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw68YqiDdLogRY0gsXh96AvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_00ed0ef8-f19e-4fa6-91a8-f94472e9b9ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "A1 Chiropractic Health and Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "183 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5337-7518-a76b-8634639ae7af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5337-7518-a76b-8634639ae7af",
        "storage_key": "property/6767906449167810/01a117cc-5337-7518-a76b-8634639ae7af.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.a1healthandwellness.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5025052547623770568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a1-chiropractic-health-and-wellness",
      "poi_latitude": "43.1884198",
      "poi_longitude": "-81.40484529999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 226-304-2340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59CAuxzdLogRyFnJDquSvEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_934a3c6b-9dc4-4f7d-a5e1-88d27b7543b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Recharge Health and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "22477 Adelaide Rd, Mount Brydges, ON N0L 1W0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-649a-717c-b8ac-a3e2536bf39a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-649a-717c-b8ac-a3e2536bf39a",
        "storage_key": "property/6767906449167810/01a117cc-649a-717c-b8ac-a3e2536bf39a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rechargehealthandfitness.ca/contact",
      "poi_directions_map_url": "https://maps.google.com/?cid=3571894433857933657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "recharge-health-and-fitness",
      "poi_latitude": "42.90817130000001",
      "poi_longitude": "-81.4933919",
      "poi_miles_from_property": "40.5",
      "poi_walking_minutes": "9 hours 3 mins",
      "poi_biking_minutes": "2 hours 13 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 519-852-7662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-zjEf-LogRWRFMGRDrkTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_24ad8373-c7a3-4b6f-8252-671d20675e27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "GoodLife Fitness Strathroy Metcalfe and Zimmerman",
      "poi_type": "Health and Wellness",
      "poi_address": "216 Metcalfe St E, Strathroy, ON N7G 1P8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-54b5-736b-8aa0-ee967e3817ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-54b5-736b-8aa0-ee967e3817ab",
        "storage_key": "property/6767906449167810/01a117cc-54b5-736b-8aa0-ee967e3817ab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.goodlifefitness.com/clubs/club.41.html?utm_source=G&utm_medium=LPM&utm_campaign=GoodlifeFitness",
      "poi_directions_map_url": "https://maps.google.com/?cid=3536525629612465860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodlife-fitness-strathroy-metcalfe-and-zimmerman",
      "poi_latitude": "42.959911",
      "poi_longitude": "-81.61464",
      "poi_miles_from_property": "36.2",
      "poi_walking_minutes": "8 hours 3 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 519-245-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGx6DFRIEL4gRxJ4dpFJDFDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_45fd0e8b-2284-476b-97b9-f95f26d20b13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "YMCA Strathroy-Caradoc Family YMCA Marilyn Buttery Branch",
      "poi_type": "Health and Wellness",
      "poi_address": "305 Frances St, Strathroy, ON N7G 4H5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ymcaswo.ca/locations/strathroy-caradoc-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=17910988976808887138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-strathroy-caradoc-family-ymca-marilyn-buttery-branch",
      "poi_latitude": "42.9494556",
      "poi_longitude": "-81.6127301",
      "poi_miles_from_property": "37.9",
      "poi_walking_minutes": "8 hours 27 mins",
      "poi_biking_minutes": "2 hours 0 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 519-245-6075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5IdWAMEL4gRYoOh8pOdkPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0fdd5cf3-30bf-4ced-a4e7-10ce9572ebc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Conservation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5420 Prince William St, North Middlesex, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4030-71fd-a947-34b1801fc401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-4030-71fd-a947-34b1801fc401",
        "storage_key": "property/6767906449167810/01a117ca-4030-71fd-a947-34b1801fc401.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.abca.ca/conservationareas/lucan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15867015411970038580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-conservation-area",
      "poi_latitude": "43.1776399",
      "poi_longitude": "-81.45787",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-235-2610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45ac-71ed-a712-84ae8cff4294",
        "storage_key": "property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8oQXj3fLogRNFsfPHP2Mtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_bf0dfccf-2939-4894-8d5a-e7204fb6d9e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Granton Centennial Park Pavillion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 High St, Lucan Biddulph, ON N0M 1V0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-397d-742e-baa8-a1b661f31d95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-397d-742e-baa8-a1b661f31d95",
        "storage_key": "property/6767906449167810/01a117ca-397d-742e-baa8-a1b661f31d95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17186530880255667799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granton-centennial-park-pavillion",
      "poi_latitude": "43.2219491",
      "poi_longitude": "-81.3007362",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45ac-71ed-a712-84ae8cff4294",
        "storage_key": "property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ1-rmnnDLogRV67rBsfSgu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dd899c70-3aa0-4609-9388-1bbf3175466a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Denfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "24015 Denfield Rd, Middlesex Centre, ON N0M 1P0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-3bf2-739e-9273-4e60c78c5c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117ca-3bf2-739e-9273-4e60c78c5c5f",
        "storage_key": "property/6767906449167810/01a117ca-3bf2-739e-9273-4e60c78c5c5f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1332528760761481489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denfield-park",
      "poi_latitude": "43.1309832",
      "poi_longitude": "-81.4340647",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45ac-71ed-a712-84ae8cff4294",
        "storage_key": "property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0ReZdHgLogREfktDtkXfhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2e0505e7-da4b-496e-a0f4-75432f366518",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Fanshawe Conservation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1424 Clarke Rd, London, ON N5V 5B9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-57ef-774e-904b-d6fa18d1b9b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-57ef-774e-904b-d6fa18d1b9b9",
        "storage_key": "property/6767906449167810/01a117cc-57ef-774e-904b-d6fa18d1b9b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fanshaweconservationarea.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9807051747272965350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fanshawe-conservation-area",
      "poi_latitude": "43.0355194",
      "poi_longitude": "-81.1883926",
      "poi_miles_from_property": "31.7",
      "poi_walking_minutes": "7 hours 6 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 519-951-6181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6b7e-70a9-b764-8013f7444227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6b7e-70a9-b764-8013f7444227",
        "storage_key": "property/6767906449167810/01a117cc-6b7e-70a9-b764-8013f7444227.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZ6Cn-bsLogR5jwUqpqlGYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_4ff7d565-99ec-4edd-94b2-ef828daef907",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Komoka Provincial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "503 Gideon Dr, London, ON N6K 4N8, Canada",
      "poi_short_description": "Unfussy day-use natural area on the Thames River with hiking trails & wildlife viewing.",
      "poi_long_description": "Unfussy day-use natural area on the Thames River with hiking trails & wildlife viewing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-57e7-736c-a639-6f03d5f3ea35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-57e7-736c-a639-6f03d5f3ea35",
        "storage_key": "property/6767906449167810/01a117cc-57e7-736c-a639-6f03d5f3ea35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ontarioparks.com/park/komoka",
      "poi_directions_map_url": "https://maps.google.com/?cid=6497524565018851320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "komoka-provincial-park",
      "poi_latitude": "42.9530318",
      "poi_longitude": "-81.3840124",
      "poi_miles_from_property": "33.1",
      "poi_walking_minutes": "7 hours 25 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 519-200-8558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-45ac-71ed-a712-84ae8cff4294",
        "storage_key": "property/6767906449167810/01a117ca-45ac-71ed-a712-84ae8cff4294.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxCPOL_7LogR-LdSoSrYK1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b714c0e5-da66-470d-8353-e2a4ef4ffe65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Main St. at William St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11976026970581540081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-main-st-at-william-st",
      "poi_latitude": "43.187559199999995",
      "poi_longitude": "-81.4026694",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6bab-712b-a073-1e85f999c007.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6bab-712b-a073-1e85f999c007",
        "storage_key": "property/6767906449167810/01a117cc-6bab-712b-a073-1e85f999c007.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8Jdo7ndLogR8ZwC-hNlM6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_c90caefd-5d1e-480e-9be7-c17ddc1a87bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Fanshawe College Parking Lot #11",
      "poi_type": "Transportation & Transit",
      "poi_address": "London, ON N5V 3C5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.middlesex.ca/ct",
      "poi_directions_map_url": "https://maps.google.com/?cid=7019754784404406412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fanshawe-college-parking-lot-11",
      "poi_latitude": "43.013131",
      "poi_longitude": "-81.198291",
      "poi_miles_from_property": "31.2",
      "poi_walking_minutes": "7 hours 1 min",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 519-520-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6bab-712b-a073-1e85f999c007.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6bab-712b-a073-1e85f999c007",
        "storage_key": "property/6767906449167810/01a117cc-6bab-712b-a073-1e85f999c007.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJq92tvQ3tLogRjADGvsgta2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_fc8d41f0-b027-40e9-be0b-b31bd0fa2a6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "CF Masonville Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "1680 Richmond St, London, ON N6G 3Y9, Canada",
      "poi_short_description": "Mall with 130 diverse stores & restaurants on 2 enclosed levels, plus an arcade & IMAX theatre.",
      "poi_long_description": "Mall with 130 diverse stores & restaurants on 2 enclosed levels, plus an arcade & IMAX theatre.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5689-7339-b2bc-f421c330f082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5689-7339-b2bc-f421c330f082",
        "storage_key": "property/6767906449167810/01a117cc-5689-7339-b2bc-f421c330f082.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://shops.cadillacfairview.com/property/cf-masonville-place",
      "poi_directions_map_url": "https://maps.google.com/?cid=14663115632450320849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cf-masonville-place",
      "poi_latitude": "43.0258005",
      "poi_longitude": "-81.2786711",
      "poi_miles_from_property": "22.6",
      "poi_walking_minutes": "5 hours 4 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 519-667-4884",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458c-75db-a3d0-499cc58596f3",
        "storage_key": "property/6767906449167810/01a117ca-458c-75db-a3d0-499cc58596f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQy6nUEPuLogR0bmtrPrZfcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e69cedc7-b807-41a1-886b-78f6b01aebe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "London International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "10 Seabrook Way, London, ON N5V 3B6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5ad6-738c-98f5-7bb08ee58888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5ad6-738c-98f5-7bb08ee58888",
        "storage_key": "property/6767906449167810/01a117cc-5ad6-738c-98f5-7bb08ee58888.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://flyyxu.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7721343355326277519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "london-international-airport",
      "poi_latitude": "43.0286636",
      "poi_longitude": "-81.1492462",
      "poi_miles_from_property": "35.8",
      "poi_walking_minutes": "8 hours 0 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 519-452-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4814-7058-9afe-dc895b1ac74a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-4814-7058-9afe-dc895b1ac74a",
        "storage_key": "property/6767906449167810/01a117ca-4814-7058-9afe-dc895b1ac74a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfcJ5iWTLogRj6cLS9-4J2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4b482295-60db-4584-bbb0-125c667f68e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "London Transit Commission",
      "poi_type": "Transportation & Transit",
      "poi_address": "450 Highbury Ave N, London, ON N5W 5L2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-57a3-75dc-9981-c367e8f3a169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-57a3-75dc-9981-c367e8f3a169",
        "storage_key": "property/6767906449167810/01a117cc-57a3-75dc-9981-c367e8f3a169.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.londontransit.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14156122682565736010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "london-transit-commission",
      "poi_latitude": "42.988098",
      "poi_longitude": "-81.1993356",
      "poi_miles_from_property": "32.5",
      "poi_walking_minutes": "7 hours 21 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 519-451-1347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75HXBoPyLogRSjYu05OmdMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_cdaaaddc-f50c-41a2-83dc-885267144bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lucan Biddulph Clerk's Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "270 Main St, Lucan Biddulph, ON N0M 2J0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-59c5-775b-96fa-9f39b0facfcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-59c5-775b-96fa-9f39b0facfcd",
        "storage_key": "property/6767906449167810/01a117cc-59c5-775b-96fa-9f39b0facfcd.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "https://www.lucanbiddulph.on.ca/about/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=4874181289754298031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucan-biddulph-clerks-office",
      "poi_latitude": "43.192412",
      "poi_longitude": "-81.4122776",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-227-4491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6ba2-7042-bf70-a167d7dfb900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6ba2-7042-bf70-a167d7dfb900",
        "storage_key": "property/6767906449167810/01a117cc-6ba2-7042-bf70-a167d7dfb900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-672QmndLogRrwap-g6SpEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_e695da8b-a89b-49b8-bcf1-ed7f31a08f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "University Hospital - London Health Sciences Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "339 Windermere Rd, London, ON N6A 5A5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5a0a-718f-8b7b-f49034545fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5a0a-718f-8b7b-f49034545fdc",
        "storage_key": "property/6767906449167810/01a117cc-5a0a-718f-8b7b-f49034545fdc.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://www.lhsc.on.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8086886192445472076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-hospital---london-health-sciences-centre",
      "poi_latitude": "43.012453099999995",
      "poi_longitude": "-81.2745418",
      "poi_miles_from_property": "24",
      "poi_walking_minutes": "5 hours 22 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 519-685-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6baa-7378-b91f-68b4d8a98962",
        "storage_key": "property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJbd_mJD7uLogRTD25VyVkOnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3efef86e-8860-4ef3-94db-40d9c6402e75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "London Health Sciences Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Commissioners Rd E, London, ON N6A 5W9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5c79-7356-89a3-1b0594777ee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5c79-7356-89a3-1b0594777ee6",
        "storage_key": "property/6767906449167810/01a117cc-5c79-7356-89a3-1b0594777ee6.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.lhsc.on.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17729682136568965391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "london-health-sciences-centre",
      "poi_latitude": "42.959901900000006",
      "poi_longitude": "-81.2268296",
      "poi_miles_from_property": "31.5",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 519-685-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6baa-7378-b91f-68b4d8a98962",
        "storage_key": "property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6BZQUnyLogRDynIovd7DPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_eaddf03d-2bd1-4166-b156-98f7ad99b29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "St. Joseph's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "268 Grosvenor St, London, ON N6A 4V2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5b9a-7498-8c08-c6e58556e9f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5b9a-7498-8c08-c6e58556e9f5",
        "storage_key": "property/6767906449167810/01a117cc-5b9a-7498-8c08-c6e58556e9f5.webp",
        "width": 500,
        "height": 281
      },
      "poi_business_url": "https://www.sjhc.london.on.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11874616999696402920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-josephs-hospital",
      "poi_latitude": "43.000957799999995",
      "poi_longitude": "-81.254751",
      "poi_miles_from_property": "26.1",
      "poi_walking_minutes": "5 hours 51 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 519-646-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6baa-7378-b91f-68b4d8a98962",
        "storage_key": "property/6767906449167810/01a117cc-6baa-7378-b91f-68b4d8a98962.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRELsXftLogR6Am4Lj8dy6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_57a20f39-d2a3-4326-91e7-906d5bdc9dc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Parkwood Institute",
      "poi_type": "Health and Wellness",
      "poi_address": "Main Building and Mental Health Care Building, 550 Wellington Rd, London, ON N6C 0A7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5ecf-77fa-9fe9-41e48600ba53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5ecf-77fa-9fe9-41e48600ba53",
        "storage_key": "property/6767906449167810/01a117cc-5ecf-77fa-9fe9-41e48600ba53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sjhc.london.on.ca/directions/parkwood-institute",
      "poi_directions_map_url": "https://maps.google.com/?cid=16539676923619287014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkwood-institute",
      "poi_latitude": "42.9559369",
      "poi_longitude": "-81.2253501",
      "poi_miles_from_property": "32",
      "poi_walking_minutes": "7 hours 15 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 519-646-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-458a-728b-ba37-f91340067916",
        "storage_key": "property/6767906449167810/01a117ca-458a-728b-ba37-f91340067916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH85IT0vyLogR5p8N9Ie8iOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2d183e42-7719-4434-897d-27c09394640d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Western University",
      "poi_type": "Education",
      "poi_address": "1151 Richmond St, London, ON N6A 3K7, Canada",
      "poi_short_description": "Dating to 1878, this public university is known for its stately architecture & business programs.",
      "poi_long_description": "Dating to 1878, this public university is known for its stately architecture & business programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5fe6-7317-9820-8ae488c60b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5fe6-7317-9820-8ae488c60b35",
        "storage_key": "property/6767906449167810/01a117cc-5fe6-7317-9820-8ae488c60b35.webp",
        "width": 1280,
        "height": 1160
      },
      "poi_business_url": "http://www.uwo.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12288057648975804827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-university",
      "poi_latitude": "43.0095971",
      "poi_longitude": "-81.2737336",
      "poi_miles_from_property": "24.4",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 519-661-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0SvEag7uLogRm3m5qlPzh6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7c2cd195-fdf4-4ff4-b80c-96546dc34861",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "London City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Dufferin Ave, London, ON N6B 1Z2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-65b4-71ca-b4b0-f2a6a33b5e9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-65b4-71ca-b4b0-f2a6a33b5e9c",
        "storage_key": "property/6767906449167810/01a117cc-65b4-71ca-b4b0-f2a6a33b5e9c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://london.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=452455776466610510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "london-city-hall",
      "poi_latitude": "42.9879902",
      "poi_longitude": "-81.246045",
      "poi_miles_from_property": "27.8",
      "poi_walking_minutes": "6 hours 15 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 519-661-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-6ba2-7042-bf70-a167d7dfb900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cc-6ba2-7042-bf70-a167d7dfb900",
        "storage_key": "property/6767906449167810/01a117cc-6ba2-7042-bf70-a167d7dfb900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaXTcATyLogRTqndqCFyRwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_157e3baf-339f-43f1-9763-528a377449d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "poi_name": "Lawson Research Institute",
      "poi_type": "Education",
      "poi_address": "268 Grosvenor St, London, ON N6A 4V2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cc-5f92-7227-95da-dc143b029d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cc-5f92-7227-95da-dc143b029d82",
        "storage_key": "property/6767906449167810/01a117cc-5f92-7227-95da-dc143b029d82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sjhc.london.on.ca/research",
      "poi_directions_map_url": "https://maps.google.com/?cid=10853113492770963357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lawson-research-institute",
      "poi_latitude": "43.000851999999995",
      "poi_longitude": "-81.2546029",
      "poi_miles_from_property": "26.1",
      "poi_walking_minutes": "5 hours 51 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 519-646-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117ca-459c-752e-8aaf-ad2a1d56fbcd",
        "storage_key": "property/6767906449167810/01a117ca-459c-752e-8aaf-ad2a1d56fbcd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP_5HNgfuLogRnb-cKzgBnpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a3495d6ab232751e6749e1ff",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_1afcb63e6cda31eb0a257549",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_3fe7c306955c5c8f9d647e15",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bce13c0d387e0871c3a93171",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_d59444ac02e83c21250fb43a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_9c7679d133fdbd3faa6b91f0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "rating": "5",
      "name": "Connie Wolcott",
      "text": "FUZE apartments in Lucan was what I called a transition spot. A place to live between houses. I hadn't lived in an apartment for a lot of years. The experience was made easy with Morgan and Tim at the helm of running and caring for these apartments.  The place was kept extremely clean with great amenities. Well set up gym, entertainment room and get together organized by staff with the residents of the apartment. Any concerns or issues. Tim was there almost immediately to look after. They both made time to chat and made you feel comfortable in your new surroundings.  Thank you to both Morgan and Tim for making my stay enjoyable.",
      "date": "2026-06-01",
      "title": "false"
    },
    {
      "id": "ec_4596c4546670b4517078c242",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "rating": "5",
      "name": "Kayla Mummery",
      "text": "Our experience here was lovely! I can not begin to explain how AMAZING this building is. Morgan and Tim are the ultimate duo, whenever I needed them they were right there . The building is immaculate, cleaners everyday!  Apartment is modern and cozy. The view from the balcony is something I will always cherish, the sunsets are BEAUTIFUL as well as the sunrises. There is a little bit of  wildlife to watch ( bunnies, ducks, muskrats ) that will keep you entertained. We also loved the entertainment room, you can enjoy yourself with guests and play some pool, Foosball, or watch the huge TV with the fireplace on. Lastly there is a full size gym that is stunning with brand new equipment and again always clean! MOVE HERE you won't regret it ! We had to move due to work but will miss this building so much 💓",
      "date": "2025-07-02",
      "title": "false"
    },
    {
      "id": "ec_9e4969ebb416c4ea817f4f84",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "rating": "5",
      "name": "Dawn Glover",
      "text": "We made an appointment to view the Fuze Lucan Apartments with Morgan Graham and they were very modern. Morgan is a very good Property Manager with excellent communication skills. She is personable, pleasant and professional, her follow-up with our questions was prompt and helpful.",
      "date": "2026-04-19",
      "title": "false"
    },
    {
      "id": "ec_dad0c683577f43be6e53147f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "rating": "5",
      "name": "Jenna Reid",
      "text": "I have lived here for about one year and happy to renew my lease for another year. I love living here, Morgan and Tim are both amazing and friendly, always happy to help and smiling and they make me feel happy to live here. Everything is always immaculately clean and the maintenance is wonderful, I have absolutely 0 complaints and I would live here forever. :D",
      "date": "2026-05-14",
      "title": "false"
    },
    {
      "id": "ec_16ceee4da458fa235a414557",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "rating": "5",
      "name": "Mike Thompson",
      "text": "I've delayed writing a review until I've lived here for a while... This is a very well run building. Morgan is always open for a chat and genuinely cares about the building and it's tennants . I'm very happy with Morgan and her team and recommend this location!",
      "date": "2025-09-26",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_82d4b341-a006-41e5-89f5-071f5162f111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Lounge + Games Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pMbQdivAS9V"
    },
    {
      "id": "custom_85158e59-7821-4cbb-a58d-417791619de9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-6727-710e-bbaf-0e3caa04cda7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a117ca-6727-710e-bbaf-0e3caa04cda7",
        "storage_key": "property/6767906449167810/01a117ca-6727-710e-bbaf-0e3caa04cda7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Centre",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AQoLhWzDu23"
    }
  ],
  "faqs": [
    {
      "id": "custom_7a155da6-8a57-4d0e-bc3a-7e1690760cee",
      "question": "What makes your community unique?",
      "answer": "At FUZE Lucan, calming natural surroundings are paired with the most innovative off-site steel construction. Live smarter, where the benefits of an apartment built with modern design and top quality building practices, gives you everything you've been looking for in your new home. We are proud to be Canadian built and Canadian owned! Visit us today to see our studio, 1 bedroom and 2 bedroom apartments available.",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_8dc61d9e-4871-4f20-be60-695559b3c36e",
      "question": "Where are you located?",
      "answer": "Nestled in the heart of Lucan, Ontario, our community boasts peaceful country living with easy access to urban amenities. Our address is 280 Main St. Lucan, ON N0M 2J0.",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_d4ee85f9-9673-4cd8-ac31-e36c3acea4c9",
      "question": "What types of floorplans do you offer?",
      "answer": "We offer Studios, 1-Bedroom, and 2-Bedroom Floorplans.",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_c3049e14-be81-448a-bf57-a5cde4e82bff",
      "question": "Is the community pet friendly?",
      "answer": "Yes! We are paw-friendly. Breed restrictions may apply.",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_1b41ea1e-9a7c-4a85-a692-93519951b1bc",
      "question": "What are your office hours?",
      "answer": "Monday, Tuesday: 10:00 AM - 5:00 PM Wednesday: 10:00 AM - 6:00 PM Thursday, Friday: 10:00AM - 5:00 PM",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_ce122187-b7f3-434a-b2b9-327882d6e638",
      "question": "How do I apply?",
      "answer": "Applications can be submited via our website at www.fuzelucan.com by selecting your desired floorplan and clicking the Lease Now button. You may also contact our office for a direct link to an application.",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_178e4ad2-b947-43da-8272-28855f90f2c3",
      "question": "What information do you need for the application?",
      "answer": "We request basic contact information, a copy of Government Issued ID (Driver's license or Passport), and two most recent pay-stubs from your place of employment. For retirees, we may request other documents for proof-of-income.",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_09fdfae4-ade6-4a75-ab8e-6b73ac7769a1",
      "question": "What are the income requirements?",
      "answer": "Our criteria is that your monthly rental amount should not exceed 40% of your monthly income. In some instances, we may require a guarantor (also known as a co-signer).",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_062db0ab-0285-4380-96b0-481992012368",
      "question": "Do you run credit checks?",
      "answer": "Yes, all applications will go through a credit screening process.",
      "category": "Leasing & Application Process",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-in-lucan-biddulph",
      "search_query": "in-unit laundry apartments Lucan Biddulph",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Lucan Biddulph",
      "h2_subtitle": "Discover in-unit laundry options at FUZE Lucan. Enjoy modern amenities and convenience in Lucan Biddulph's vibrant community.",
      "page_copy": "Live the ultimate convenience at FUZE Lucan, where in-unit laundry apartments in Lucan Biddulph redefine comfort and modern living. Our community offers not only the luxury of laundry facilities in your own apartment but also features like 9' ceilings and roller blinds, ensuring a contemporary lifestyle.\n\nAt FUZE Lucan, enjoy a host of amenities right at your doorstep. From visitor parking and a fully-equipped Fitness Centre to secure indoor bike storage, we cater to every resident's needs. Nestled in Middlesex County, our prime location provides easy access to local attractions and seamless connectivity to the larger cityscape, making daily living a breeze.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments | Lucan Biddulph",
      "seo_description": "Explore in-unit laundry apartments at FUZE Lucan and enjoy top amenities in Lucan Biddulph. Experience seamless, modern living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-middlesex-county",
      "search_query": "air conditioned apartments in Middlesex County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Middlesex County",
      "h2_subtitle": "Stay cool in air conditioned apartments at FUZE Lucan. Our Middlesex County location offers comfort and modern amenities.",
      "page_copy": "Experience the comfort of air conditioned apartments at FUZE Lucan, perfectly situated in Middlesex County. Enjoy a cool, refreshing home environment alongside our premium amenities such as visitor parking and a state-of-the-art Fitness Centre. High ceilings and roller blinds complement our apartments, offering both style and function.\n\nLocated in the heart of Lucan Biddulph, FUZE Lucan provides easy access to everything Middlesex County has to offer. With indoor bike storage available, residents can explore the scenic surroundings conveniently. Live in comfort and style with air conditioned living spaces designed for modern lifestyles.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments | Middlesex County",
      "seo_description": "Discover air conditioned apartments at FUZE Lucan in Middlesex County. Experience modern comfort and amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "dedicated-parking-apartments-lucan",
      "search_query": "apartments with dedicated parking Lucan",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking in Lucan",
      "h2_subtitle": "Enjoy the convenience of dedicated parking at FUZE Lucan. Our Lucan Biddulph location offers modern amenities for comfortable living.",
      "page_copy": "At FUZE Lucan, enjoy the luxury of apartments with dedicated parking in Lucan. Our facility ensures that you always have a parking spot ready, making daily life hassle-free. Complemented by a range of features like indoor bike storage and a fitness centre, FUZE Lucan enhances living convenience.\n\nLocated in the welcoming community of Lucan Biddulph, our prime location offers easy access to local attractions and amenities. With roller blinds and 9' ceilings in our apartments, you can relish in style and comfort every day. Experience a seamless, stress-free lifestyle with dedicated parking and more at FUZE Lucan.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dedicated Parking Apartments | Lucan",
      "seo_description": "Find dedicated parking apartments at FUZE Lucan. Enjoy modern amenities and convenience in Lucan's prime location for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "modern-apartments-dishwasher-on",
      "search_query": "modern apartments with dishwasher ON",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Dishwasher in ON",
      "h2_subtitle": "Explore modern living at FUZE Lucan with dishwashers included. Located in ON, enjoy top-notch amenities and comfort.",
      "page_copy": "Discover FUZE Lucan's modern apartments featuring dishwashers, nestled within the vibrant community of ON. Our residences combine style and convenience, offering amenities such as 9' ceilings and cutting-edge roller blinds. Each unit is designed with your lifestyle in mind, providing efficiency and ease.\n\nLocated in Lucan Biddulph, our community offers seamless access to local attractions and services. Take advantage of amenities like visitor parking, a fully-equipped fitness centre, and indoor bike storage. FUZE Lucan ensures a holistic living experience, combining sleek design with practical features such as dishwashers to enhance your daily routine.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Dishwasher | ON",
      "seo_description": "Discover modern apartments with dishwashers at FUZE Lucan. Live comfortably with top amenities in ON's prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-wash-station-n0m-2j0",
      "search_query": "pet-friendly apartments with dog wash station near N0M 2J0",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Wash Station",
      "h2_subtitle": "Find pet-friendly apartments near N0M 2J0 with a dog wash station at FUZE Lucan. Enjoy a community that loves your pets as much as you do.",
      "page_copy": "Welcome to FUZE Lucan, where our pet-friendly apartments, complete with a convenient dog wash station, ensure that your furry friends find the perfect home too. Located near N0M 2J0, FUZE Lucan offers not only a welcoming environment for pets but also premium amenities like a fitness centre and indoor bike storage for you.\n\nOur Lucan Biddulph location is designed to meet the needs of modern pet owners, with easy access to local parks and trails. Inside each apartment, enjoy upscale features such as roller blinds and lofty 9' ceilings to make both you and your pet feel comfortable. At FUZE Lucan, we cater to a lifestyle where pet-friendly meets modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Wash | Near N0M 2J0",
      "seo_description": "Explore pet-friendly apartments with a dog wash station at FUZE Lucan near N0M 2J0. Enjoy comfort and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "studio-apartments-lucan-biddulph",
      "search_query": "studio apartments Lucan Biddulph",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Lucan Biddulph",
      "h2_subtitle": "Discover cozy studio apartments at FUZE Lucan in Lucan Biddulph. Enjoy modern amenities and a vibrant community.",
      "page_copy": "Located in the heart of Lucan Biddulph, FUZE Lucan offers charming studio apartments perfect for those seeking a modern yet cozy living space. Our units are thoughtfully designed with high ceilings and stylish roller blinds, creating an open, airy feel.\n\nResidents of FUZE Lucan can take advantage of a range of amenities such as the fitness centre, indoor bike storage, and convenient visitor parking. Situated within a lively community, our studio apartments provide excellent access to local shops, dining, and activities while ensuring a comfortable living environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments | Lucan Biddulph",
      "seo_description": "Find studio apartments in Lucan Biddulph at FUZE Lucan. Enjoy comfort and modern amenities in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "1-bedroom-apartment-on-n0m-2j0",
      "search_query": "1 bedroom apartment ON N0M 2J0",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartment in ON N0M 2J0",
      "h2_subtitle": "Experience comfortable living in a 1 bedroom apartment at FUZE Lucan. Located in ON N0M 2J0, enjoy modern amenities and community.",
      "page_copy": "At FUZE Lucan, find your ideal 1-bedroom apartment in the serene locality of ON N0M 2J0. Each apartment is designed with your comfort in mind, featuring 9' ceilings and elegant roller blinds. Our modern units provide a spacious retreat after a bustling day.\n\nResidents benefit from a variety of amenities, including a stylish fitness centre and secure indoor bike storage. The community offers the convenience of nearby shopping and dining, along with excellent access to local attractions. FUZE Lucan is your gateway to dynamic living in Lucan Biddulph, tailored for your lifestyle needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartment | ON N0M 2J0",
      "seo_description": "Discover a 1 bedroom apartment at FUZE Lucan in ON N0M 2J0. Enjoy modern living with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-middlesex-county",
      "search_query": "2 bedroom apartments Middlesex County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Middlesex County",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at FUZE Lucan in Middlesex County. Enjoy modern amenities and a vibrant community lifestyle.",
      "page_copy": "Nestled in the heart of Middlesex County, FUZE Lucan offers stylish and spacious 2 bedroom apartments designed to fit your lifestyle needs. Each unit features high-end finishes like 9' ceilings and contemporary roller blinds, making it an inviting place to call home.\n\nOur residents enjoy premium amenities that include a fully-equipped fitness centre and convenient indoor bike storage. With visitor parking available, FUZE Lucan provides all the necessities for comfortable living. Situated near local attractions, shopping, and dining, our community is perfect for those seeking both tranquility and convenience in Middlesex County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments | Middlesex County",
      "seo_description": "Find spacious 2 bedroom apartments in Middlesex County at FUZE Lucan. Modern living with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "apartments-near-denfield-park-ontario",
      "search_query": "apartments near Denfield Park Ontario",
      "category": "Park",
      "h1_title": "Apartments Near Denfield Park, Ontario",
      "h2_subtitle": "Explore premium apartments near Denfield Park, Ontario at FUZE Lucan. Enjoy modern amenities and a vibrant lifestyle close to nature.",
      "page_copy": "FUZE Lucan offers exceptional apartments near Denfield Park, Ontario, providing a perfect blend of urban living and natural surroundings. Each apartment is thoughtfully designed with features like 9' ceilings and roller blinds, ensuring a comfortable and stylish home.\n\nSituated conveniently close to Denfield Park, residents can enjoy the tranquility of nature just steps away. Our community includes a fitness centre and indoor bike storage, along with visitor parking, offering a holistic lifestyle experience. Embrace the vibrant life at FUZE Lucan, with easy access to local amenities and outdoor leisure activities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Denfield Park | Ontario",
      "seo_description": "Find apartments near Denfield Park, Ontario at FUZE Lucan. Modern amenities in a vibrant setting next to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167810",
      "source": "custom",
      "page_item_url": "rentals-close-to-granton-centennial-park",
      "search_query": "rentals close to Granton Centennial Park Middlesex County",
      "category": "Park",
      "h1_title": "Rentals Near Granton Centennial Park",
      "h2_subtitle": "Discover rentals near Granton Centennial Park in Middlesex County at FUZE Lucan. Enjoy modern living and easy access to recreational spaces.",
      "page_copy": "Located just a short distance from Granton Centennial Park, FUZE Lucan offers premium rentals in Middlesex County that combine comfort and convenience. Our rentals feature modern amenities, including 9' ceilings and pristine roller blinds, creating a welcoming atmosphere.\n\nResidents at FUZE Lucan can take advantage of our state-of-the-art fitness centre and ample indoor bike storage, adding more value to their living experience. With Granton Centennial Park nearby, you can explore numerous recreational opportunities while enjoying the community life and local amenities that make FUZE Lucan an ideal choice for residents looking for rentals close to Granton Centennial Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Granton Centennial Park | Middlesex",
      "seo_description": "Find rentals near Granton Centennial Park at FUZE Lucan in Middlesex County. Enjoy modern living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "13230426636"
    },
    {
      "ID": "custom_fenix_chatbot",
      "type": "STRING",
      "value": "30720"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Aster"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58860784795"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yzvg82r7pln"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_repli_id": "13230426636",
  "custom_fenix_chatbot": "30720",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Aster",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "58860784795",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yzvg82r7pln",
  "custom_website_subscription": "turnkey",
  "custom_audioeye_site_id": "ef5d30ef-5738-46c8-a35c-698ce04f5784",
  "custom_audioeye_site_hash": "a2d7c2d8d1dafe4776d364997839ba95"
};

export const generatedAt = '2026-11-03T18:40:04.571Z';
